
function apply_polyfills() {
	// unfortunately namespaced callbacks don't work currently (August 2018)
	function generic_captcha_callback(a) {
		jQuery(document).trigger('captcha_success', a);
		// return new Promise(function(resolve, reject) {
		// 	jQuery(document).trigger('captcha_success', a);
		// 	resolve();
		// });
	}
	
	// https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Object/entries
	if (!Object.entries) {
		Object.entries = function( obj ){
			var ownProps = Object.keys( obj ),
				i = ownProps.length,
				resArray = new Array(i); // preallocate the Array
			while (i--)
				resArray[i] = [ownProps[i], obj[ownProps[i]]];
			
			return resArray;
		};
	}
	// https://sentry.io/organizations/yalwa/issues/2563605516
	// https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
	if (!String.prototype.repeat) {
		String.prototype.repeat = function(count) {
			'use strict';
			if (this == null) {
				throw new TypeError('can\'t convert ' + this + ' to object');
			}
			var str = '' + this;
			count = +count;
			if (count != count) {
				count = 0;
			}
			if (count < 0) {
				throw new RangeError('repeat count must be non-negative');
			}
			if (count == Infinity) {
				throw new RangeError('repeat count must be less than infinity');
			}
			count = Math.floor(count);
			if (str.length == 0 || count == 0) {
				return '';
			}
			// Ensuring count is a 31-bit integer allows us to heavily optimize the
			// main part. But anyway, most current (August 2014) browsers can't handle
			// strings 1 << 28 chars or longer, so:
			if (str.length * count >= 1 << 28) {
				throw new RangeError('repeat count must not overflow maximum string size');
			}
			var rpt = '';
			for (var i = 0; i < count; i++) {
				rpt += str;
			}
			return rpt;
		}
	}
}
apply_polyfills();

jQuery.fn.on_once = function(...args) {
	if (typeof args[0] === "object") {
		const events = args[0];
		const rest_args = args.slice(1);
		for (const [event, handler] of Object.entries(events)) {
			const [event_name, namespace] = event.split(".");
			if (!namespace) {
				console.warn(`on_once requires a namespace for "${event}"`);
				continue;
			}
			this.off(event).on(event, handler, ...rest_args);
		}
		return this;
	}
	
	const event_string = args[0];
	if (!event_string.includes(".")) {
		console.warn(`on_once requires a namespace for "${event_string}"`);
		return this;
	}
	
	return this.off(event_string).on(...args);
};

jQuery.fn.off_namespace = function(namespace) {
	if (!namespace) {
		console.warn("off_namespace requires a namespace");
		return this;
	}
	return this.off(`.${namespace}`);
};

yalwa.basics = (function(pub) {
	'use strict';
	
	const debounce_refs = new Map();
	const expiration_suffix = '-expiration';
	const REGENERATE_THRESHOLD = 3600;
	const RELOAD_CHECK_THRESHOLD = 300; // 5 minutes in seconds

	pub = pub || {};
	
	pub.ONE_MINUTE = 60;
	pub.ONE_HOUR = 3600;
	pub.ONE_DAY = 86400;
	pub.ONE_WEEK = 604800;
	pub.ONE_MONTH = 2592000;
	pub.ONE_YEAR = 31536000;

	pub.API_PATH = '/api/ajax/dol/';
	pub.API_PATH_DOL = '/api/ajax/dol/';

	let nav_started = false;
	let check_stylesheet_polyfill_needed_promise;
	
	pub.init = function() {
		use_passive_event_listeners_globally();
		if (yalwa.v.js_path) {
			yalwa.v.css_path = yalwa.v.js_path.replace('/js/', '/styles/');
		}
		const ua = navigator.userAgent.toLowerCase();
		yalwa.v.is_phonegap = (ua.indexOf('yalwapp') > -1);
		yalwa.v.is_ios = ua.indexOf('iphone') !== -1 || ua.indexOf('ipad') !== -1 || /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
		// init cordova module early as possible
		yalwa.basics.app_module_load_handler.init();
		pub.ga.init();

		session_storage_age_init();
		pub.sw.init();
		init_nonprod();
		if (yalwa.v.is_phonegap) {
			if (!yalwa.v.is_ios) {
				// WARNING! Please not activate fastclick.js. We do not needed this any more and have side effects.
			}
			jQuery('.js-openexternal').on('click', yalwa.basics.openexternal_click); // beware used via cordova please don't move it used in UHP!!!
		}
		pub.fingerprint.check();

		init_promotion_tracking();
		if (!yalwa.basics.ls_get('uac_reset') || parseInt(yalwa.basics.ls_get('uac_reset')) < 1565647200) {
			yalwa.basics.ls_set('uac_reset', yalwa.basics.unix());
			yalwa.basics.ls_remove('uac');
		}
		if (yalwa.v.uac_userID && !yalwa.v.scache) {
			var uac = yalwa.basics.ls_get('uac', true) || [];
			var count_before = uac.length;
			uac.push(yalwa.v.uac_userID);
			var uac_new = uac.filter(filter_unique);
			yalwa.basics.ls_set('uac', uac_new);
			if (!yalwa.basics.ls_get('uac_u')) {
				yalwa.basics.ls_set('uac_u', pub.create_uuid());
			}
			if (count_before && count_before != uac_new.length && uac_new.length > 1) {
				uac_send(yalwa.basics.ls_get('uac_u'), yalwa.basics.ls_get('uac', true));
			}
		}

		init_on_logout();
		pub.webpush.init();

		if (!yalwa.basics.get_cookie('testing_cookie')) {
			yalwa.basics.set_cookie('testing_cookie', 1);
		}

		if (yalwa.v.seen_with_dol_account) {
			yalwa.basics.ls_set('seen_with_dol_account', true);
		}
		yalwa.basics.overlay.init();
		track_core_web_vitals();

		// initialize regenerate routine and fingerprint check/reload when user is logged in
		if (yalwa.basics.is_logged_in()) {
			yalwa.basics.ls_set('last_regenerate_ts', yalwa.basics.unix());
			init_regenerate_routine();
			init_check_reload_needed();
		}
		if (yalwa.basics.get_get('regenerate') === 'push') { // covers both webpush and cordova
			yalwa.basics.label('endpoint_confirmed_toast', 'main').done((label) => {
				yalwa.basics.toast({message: label, type: 'success'});
				yalwa.basics.set_get({'regenerate': null}, false, false);
			});
		}
		jQuery(window).on('pageshow', (event) => {
			if (event.originalEvent.persisted) { // bfcache
				yalwa.basics.ga.pageview({page: document.location.pathname, location: document.location.href});
			}
		});
		DEV_9572_increase();
		remove_srl_artifacts();
	};
	
	pub.check_stylesheet_polyfill_needed = function() {
		if (check_stylesheet_polyfill_needed_promise) {
			return check_stylesheet_polyfill_needed_promise;
		}

		check_stylesheet_polyfill_needed_promise = (async function() {
			try {
				const has_doc = 'adoptedStyleSheets' in Document.prototype;
				let has_shadow = false;
				try {
					has_shadow = 'adoptedStyleSheets' in ShadowRoot.prototype;
				} catch {
					has_shadow = false;
				}
				const has_css_stylesheet = typeof CSSStyleSheet !== 'undefined';
				const has_replace_sync = has_css_stylesheet && typeof CSSStyleSheet.prototype.replaceSync === 'function';
				let can_construct = false;
				if (has_css_stylesheet) {
					try {
						new CSSStyleSheet();
						can_construct = true;
					} catch {
						can_construct = false;
					}
				}
				if (has_doc && has_shadow && has_css_stylesheet && has_replace_sync && can_construct) {
					return;
				}
			} catch (e) {

			}
			return new Promise((resolve, reject) => {
				const script = document.createElement('script');
				script.async = true;
				script.defer = true;
				script.src = yalwa.basics.static_url('js') + 'external/adoptedStyleSheets.js';
				script.onload = resolve;
				script.onerror = () => reject(new Error('Failed to load construct-style-sheets polyfill'));
				document.head.appendChild(script);
			});
		})();
		return check_stylesheet_polyfill_needed_promise;
	};
	
	function remove_srl_artifacts() {
		if (yalwa.basics.is_logged_in()) {
			yalwa.basics.set_get({'srlp': null});
			yalwa.basics.set_cookie('srlp', 0, -1);
		}
	}
	
	pub.app_module_load_handler = (function(pub) {
		
		pub = pub || {};
		
		pub.init = function() {
			//dol_android, dol_ios or false
			yalwa.v.is_dol_app = yalwa.basics.is_dol_app();
			if (yalwa.v.is_phonegap) {
				if(yalwa.v.is_dol_app) {
					pub.deferred = jQuery.Deferred();
					pub.is_loaded = pub.deferred.promise();
				}
			}
		};
		return pub;
		
	}(pub.app_module_load_handler));
	
	function use_passive_event_listeners_globally() {
		// https://github.com/jquery/jquery/issues/2871
		jQuery.event.special.touchstart = {
			setup: function( _, ns, handle ) {
				this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
			}
		};
		jQuery.event.special.touchmove = {
			setup: function( _, ns, handle ) {
				this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
			}
		};
		jQuery.event.special.wheel = {
			setup: function( _, ns, handle ){
				this.addEventListener("wheel", handle, { passive: true });
			}
		};
		jQuery.event.special.mousewheel = {
			setup: function( _, ns, handle ){
				this.addEventListener("mousewheel", handle, { passive: true });
			}
		};
	}
	
	function regenerate() {
		yalwa.basics.ls_set('last_regenerate_ts', yalwa.basics.unix());
		return jQuery.ajax({
			url: '/api/ajax/general',
			type: 'post',
			data: {
				action: 'regenerate_login'
			},xhrFields: {
				withCredentials: true
			}
		});
	}

	function init_regenerate_routine() { // post requests might fail when the page was open for a long time and session expired
		document.addEventListener('visibilitychange', regenerate_check);
	}
	
	function regenerate_check() {
		if (
			document.visibilityState === 'visible'
			&& yalwa.basics.ls_get('last_regenerate_ts')
			&& yalwa.basics.is_logged_in()
			&& (yalwa.basics.unix() - yalwa.basics.ls_get('last_regenerate_ts') > REGENERATE_THRESHOLD)
		) {
			regenerate();
		}

	}
	
	pub.regenerate_login = regenerate;

	function init_check_reload_needed() {
		if (!yalwa.v.scache) {
			document.addEventListener('visibilitychange', check_reload_needed);
		}
	}

	/**
	 * reload the page when the last reload time is 5 minutes ago and there is new fingerprint available
	 * @see https://yalwa.atlassian.net/browse/DEV-2971
	 */
	function check_reload_needed() {
		if (location.port) {
			return; // disabled by Philipp, not always helpful on dev, since you might want to preserve a specific state
		}
		if (document.visibilityState === 'visible'
			&& yalwa.basics.ls_get('last_regenerate_ts')
			&& yalwa.basics.is_logged_in()
			&& (yalwa.basics.unix() - yalwa.basics.ls_get('last_regenerate_ts') > RELOAD_CHECK_THRESHOLD)) {
			get_fingerprint().done(function(response) {
				if (response && response.success) {
					const revision_number = yalwa.basics.revision_number();
					let DOM_fingerprint;
					if (revision_number && typeof revision_number === 'string') {
						DOM_fingerprint = revision_number.replace('/', '');
					}

					const last_check_loaded_ts = yalwa.basics.ls_get('last_check_reloaded_ts');
					// when the server finger print and DOM finger print are different reload the page
					if (DOM_fingerprint
						&& response.fingerprint
						&& DOM_fingerprint !== response.fingerprint
						&& (!last_check_loaded_ts || yalwa.basics.unix() - last_check_loaded_ts > RELOAD_CHECK_THRESHOLD)
					) {
						yalwa.basics.ls_set('last_check_reloaded_ts', yalwa.basics.unix());
						yalwa.basics.reload();
					}
				}
			});
		}
	}

	function get_fingerprint() {
		return jQuery.ajax({
			url: '/api/ajax/general',
			type: 'get',
			dataType: 'json',
			data: { action: 'get_fingerprint'},
			cache: false
		});
	}

	function track_core_web_vitals() {
		if (yalwa.basics.get_random_int(1,10) === 1) {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/webvitals.min.js', () => {
				webVitals.onCLS(send_to_analytics);
				webVitals.onFID(send_to_analytics);
				webVitals.onLCP(send_to_analytics);
				webVitals.onINP(send_to_analytics);
				webVitals.onTTFB(send_to_analytics);
				webVitals.onFCP(send_to_analytics);
			});
		}
	}

	pub.app_type = function() {
		return yalwa.basics.ga.dimension_get('CD_DOL_APPTYPE');
	};

	pub.revision_number = function() {
		return yalwa.basics.ga.dimension_get('CD_DOL_APPVERSION');
	};

	function send_to_analytics(metric) {
		yalwa.basics.beacon('/api/ajax/track/', {
			t: 'web-vitals',
			page_type: 'DOL',
			app_type: pub.app_type(),
			metric: metric.name,
			value: metric.value,
			is_nationwide: 3,
			scache: 0,
		});
	}

	function session_storage_age_init() {
		if (!yalwa.basics.ss_get('sessionStorage_age')) {
			yalwa.basics.ss_set('sessionStorage_age', yalwa.basics.unix());
		}
	}

	pub.session_storage_age = function() {
		if (yalwa.basics.ss_get('sessionStorage_age')) {
			return yalwa.basics.unix() - yalwa.basics.ss_get('sessionStorage_age');
		} else {
			return null;
		}
	};

	const load_deferreds = {};

	function resolve_asset_url(url) {
		const match = url.match(/\/assets\/[\d_]+\/(js|styles)\/(.+)$/);
		if (!match) {
			return Promise.resolve(url);
		}
		const type = match[1];
		const path = match[2];

		// fonts use a static 1_1 makeref, no filemtime resolution needed
		if (path.indexOf('fonts/') === 0) {
			return Promise.resolve(url);
		}

		// check pre-resolved hot_assets tokens first (server-side injected via php_var_to_js)
		const hot_token = yalwa.v.hot_assets && yalwa.v.hot_assets[type] && yalwa.v.hot_assets[type][path];
		if (hot_token) {
			return Promise.resolve(url.replace(/\/assets\/[\d_]+\//, '/assets/' + hot_token + '/'));
		}

		const cache_key = 'afu:' + (yalwa.v.fingerprint || '') + ':' + type + ':' + path;

		let cached = yalwa.basics.ls_get(cache_key);
		if (cached) {
			return Promise.resolve(cached);
		}

		return jQuery.ajax({
			url: '/api/ajax/general',
			type: 'get',
			dataType: 'json',
			data: {action: 'get_asset_url', type: type, path: path},
			cache: false
		}).then(function (response) {
			if (response && response.success && response.url) {
				yalwa.basics.ls_set(cache_key, response.url);
				return response.url;
			}
			yalwa.basics.ls_set(cache_key, url); // cache fallback so we don't retry every load
			return url;
		}, function () {
			yalwa.basics.ls_set(cache_key, url); // AJAX failed → cache fallback
			return url;
		});
	}

	pub.load_js = function(url, callback, type, no_crossorigin, attributes, data_attributes) {
		if (!load_deferreds[url]) {
			const d = jQuery.Deferred();
			resolve_asset_url(url).then(function (resolved_url) {
				const script = document.createElement('script');
				script.onload = () => {
					d.resolve();
				};
				script.onerror = () => {
					console.error(`Failed to load script: ${resolved_url}`);
					d.reject(`Script load error for ${resolved_url}`);
				};
				script.src = resolved_url;
				script.type = type ? type : '';
				if (!no_crossorigin) {
					script.crossOrigin = 'anonymous';
				}
				if (attributes) {
					attributes.forEach(attribute => {
						script[attribute] = true;
					})
				}
				if (data_attributes) {
					Object.keys(data_attributes).forEach(key => {
						script.setAttribute('data-' + key, data_attributes[key]);
					});
				}
				document.head.appendChild(script);
			}, function () {
				d.reject();
			});
			load_deferreds[url] = d.promise();
		}
		return load_deferreds[url].done(() => {
			if (typeof callback === 'function') {
				callback();
			}
		});
	};

	pub.fingerprint = function(pub) {

		const key_hash = 'fingerprint';
		const key_ID = 'fingerprintID';

		pub = pub || {};

		pub.check = function() {
			if (!yalwa.basics.is_logged_in()) {
				return;
			}
			if (!yalwa.basics.ss_get(key_hash)) {
				// calc fingerprint only once during session
				try {
					load().done(determine);
				} catch (error) {
				
				}
			}
		}

		pub.getID = function() {
			return yalwa.basics.ls_get(key_ID);
		}

		function determine() {
			if (window.requestIdleCallback) {
				requestIdleCallback(store);
			} else {
				setTimeout(store, 500);
			}
		}

		function store() {
			Fingerprint2.getPromise().then((components) => {
				let hash = calc_hash(components);
				yalwa.basics.ss_set(key_hash, hash);
				send_to_server(hash);
			});
		}

		pub.get_hash = async function () {
			try {
				await load();
				const components = await Fingerprint2.getPromise();
				let hash = calc_hash(components);
				return hash;
			} catch (error) {
				return null;
			}
		};
		
		function calc_hash(components) {
			return Fingerprint2.x64hash128(components.map((c) => c.value).join(''), 31);
		}

		function send_to_server(hash) {
			return jQuery.ajax({
				url: '/api/ajax/save_fingerprint/',
				type: 'post',
				data: {
					fingerprint: hash,
					ua: navigator.userAgent
				}
			}).done(function(fingerprintID) {
				if (fingerprintID > 0) {
					// store latest ID in localStorage
					yalwa.basics.ls_set(key_ID, fingerprintID);
				}
			});
		}

		function load() {
			return yalwa.basics.load_js('https://cdnjs.cloudflare.com/ajax/libs/fingerprintjs2/2.1.0/fingerprint2.min.js');
		}

		return pub;

	}(pub.fingerprint);

	pub.load_css = function(url) {
		if (Array.isArray(url)) {
			jQuery.each(url, (i,e) => {yalwa.basics.load_css(e);});
			return;
		}
		if (!load_deferreds[url]) {
			load_deferreds[url] = true;
			resolve_asset_url(url).then(function (resolved_url) {
				const link = document.createElement('link');
				link.rel = 'stylesheet';
				link.type = 'text/css';
				link.href = resolved_url;
				document.head.appendChild(link);
			});
		}
	};

	pub.openexternal_click = function(e) { // beware used via cordova please don't move it used in UHP!!!
		e.preventDefault();
		e.stopPropagation();
		yalwa.basics.openexternal(jQuery(this).prop('href'));
		return false;
	};

	pub.openexternal = function(url) { // beware used via cordova please don't move it used in UHP!!!
		if (yalwa.basics.yalwapp_version() >= 240) {
			yalwa.basics.cordova_send({action: 'openexternal', params: {url: url}});
		}
	};

	pub.openwebintent = function(url) { // beware used via cordova
		if (yalwa.basics.yalwapp_version() >= 250) {
			yalwa.basics.cordova_send({action: 'openpartner', params: {url: url}});
		} else {
			yalwa.basics.openexternal(url);
		}
	};

	pub.opensecondwebview = function(url) { // beware used via cordova
		if (yalwa.basics.yalwapp_version() >= 270) {
			yalwa.basics.cordova_send({action: 'opensecondwebview', params: {url: url}});
		} else {
			yalwa.basics.openexternal(url);
		}
	};

	pub.cordova_send = function(object) { // beware used via cordova please don't move it used in UHP!!!
		if (yalwa.v.is_phonegap) {
			yalwa.v.send_pending = yalwa.v.send_pending || [];
			yalwa.v.send_pending.push(object);
		}
	};
	pub.cordova_collect = function() { // beware used via cordova please don't move it used in UHP!!!
		var pending = yalwa.v.send_pending;
		if (pending) {
			yalwa.v.send_pending = null;
		}
		return {items: pending, timeout: 500};
	};

	function uac_send(uac_u, uac) {
		jQuery.ajax({
			url: '/api/ajax/general/',
			type: 'post',
			data: {
				action: 'uac',
				uac_u: uac_u,
				uac: JSON.stringify(uac)
			},
			dataType: 'json'
		}).done(function(r) {
			if (r.other_uuid) {
				yalwa.basics.ls_set('uac_u', r.other_uuid);
			}
			if (r.reset) {
				yalwa.basics.ls_set('uac_reset', yalwa.basics.unix());
				yalwa.basics.ls_remove('uac');
			}
		});
	}

	pub.before_logout = function() {
		yalwa.basics.webpush.unsubscribe();
	};

	function init_on_logout() {
		const $logout_link = jQuery('.js-logout');
		$logout_link.on('click', function(e) {
			e.preventDefault();
			pub.before_logout();
		});
	}

	function filter_unique(value, index, self) {
		return self.indexOf(value) === index;
	}

	function init_promotion_tracking() {
		jQuery('.js-promotion').on('click', function() {
			var $promotion = jQuery(this);
			var promo_touchpoint = $promotion.data('promo_touchpoint');
			var promo_name = $promotion.data('promotion_name');
			yalwa.basics.set_cookie('track_promotion_click', promo_touchpoint + '--' + promo_name, 86400);
			return true;
		});
	}

	pub.is_pwa = function() {
		if (window.navigator.standalone === true) {
			return true;
		}
		if (typeof(matchMedia) === 'function' && matchMedia('(display-mode: standalone)').matches) {
			return true;
		}
		return false;
	};
	
	pub.is_pwa_dating = function() {
		return yalwa.basics.get_cookie('pwa_dating');
	};

	function init_nonprod() {
		if (location.port) {
			yalwa.basics.load_js(jQuery('[src$="dol/main.js"]').attr('src').replace('dol/main', 'shared/dev'));
		}
	}

	function parse_app_agent() {
		const user_agent_string = navigator.userAgent;
		const regex = /^.*YalwApp\/([iabcdefg])([AYL]).([0-9]*).([0-9]*).([0-9]*)/;
		return regex.exec(user_agent_string);
	}

	function get_app_type(matches) {
		return matches ? matches[1] : null;
	}

	pub.is_dol_app = function() {
		const matches = parse_app_agent();
		if(get_app_type(matches) === 'e') {
			return 'dol_android';
		} else if(get_app_type(matches) === 'f') {
			return 'dol_ios';
		} else {
			return false;
		}
	};
	
	function  get_cordova_app_detection_regex() {
		let regex = /(^|[ \t])YalwApp\/[abcdefg][AYL]\.(\d+)\.(\d+)\.(\d+)(\/\d{1,2})?([ \t]|$)/;
		return regex;
	}

	pub.dol_app_version = function(visual=false) {
		var matches = navigator.userAgent.match(/YalwApp\/[abcdefg]L\.([0-9])\.([0-9])\.([0-9][0-9])/);
		let separator = visual ? '.' : '';
		if (matches && matches[1] && matches[2] && matches[3]) {
			if(visual) {
				if(matches[4]) {
					return matches[1] + separator + matches[2] + separator + matches[3] + matches[4] + (location.port ? (location.port > 4500 ? ' d' : ' dev') + location.port.slice(-2) : '');
				} else {
					return matches[1] + separator + matches[2] + separator + matches[3] + (location.port ? (location.port > 4500 ? ' d' : ' dev') + location.port.slice(-2) : '');
				}
			} else {
				if(matches[4]) {
					return parseInt(matches[1] + matches[2] + matches[3] + matches[4], 10);
				} else {
					return parseInt(matches[1] + matches[2] + matches[3], 10);
				}
			}
		}
		return 0;
	};

	pub.init_wrapper = function(callback) {
		jQuery(callback);
	};

	pub.get_random_int = function(min, max) {
		min = Math.ceil(min);
		max = Math.floor(max);
		return Math.floor(Math.random() * (max - min + 1)) + min;
	};

	pub.random_percentage = function(percent) {
		var random = Math.random();
		return random <= (percent / 100) ? true : false;
	};
	
	function cookie_name_final(cookie_name) {
		const whitelist = yalwa.v.cookie_names_whitelist || [];
		const cookie_prefix = yalwa.v.cookie_prefix;
		if (whitelist.includes(cookie_name) && cookie_prefix) {
			return `${cookie_prefix}${cookie_name}`;
		} else {
			return cookie_name;
		}
	}

	pub.get_cookie = function(cookie_name) {
		if (typeof (document.cookie) === 'undefined') {
			return false;
		}
		cookie_name = cookie_name_final(cookie_name);
		// https://stackoverflow.com/a/21125098/333864
		let match = document.cookie.match(new RegExp('(^| )' + cookie_name + '=([^;]+)'));
		if (match) {
			return match[2];
		} else {
			return false;
		}
	};

	pub.set_cookie = function(cookie_name, content, duration) {
		var domain;
		if (yalwa.v.cookie_domain) {
			domain = yalwa.v.cookie_domain;
		} else {
			var host = window.location.href.replace((location.protocol ? location.protocol : 'http:') + '//', '').split('/')[0];
			host = host.split('.');
			var pos = host.length - 1;
			if (host[pos].search(/:/)) {
				host[pos] = host[pos].split(':')[0]; // remove port
			}
			domain = host[pos - 1] + '.' + host[pos];
			if (host[pos - 1] === 'co' || host[pos - 1] === 'com') {
				domain = host[pos - 2] + '.' + domain;
			}
			if (typeof(arguments[3]) !== 'undefined' && arguments[3]) {
				var i = pos - 2;
				while (i >= 0) {
					domain = host[i] + '.' + domain;
					i--;
				}
			}
		}
		cookie_name = cookie_name_final(cookie_name);
		var c = cookie_name + '=' + content + '; domain=' + domain + '; path = /; Secure; SameSite=Lax';
		if (duration) {
			var d = new Date();
			d = new Date(d.getTime() + 1000 * duration);
			c += '; expires=' + d.toGMTString();
		}
		document.cookie = c;
	};

	/**
	 * @desc executes the given function (fn) at the given threshold interval, useful for scrolling and resize events
	 * @param fn
	 * @param threshold
	 * @param scope
	 * @returns {(function(): void)|*}
	 */
	pub.throttle = function(fn, threshold, scope) {
		threshold || (threshold = 250);
		var last,
			deferTimer;
		return function() {
			var context = scope || this;

			var now = +new Date,
				args = arguments;
			if (last && now < last + threshold) {
				// hold on to it
				clearTimeout(deferTimer);
				deferTimer = setTimeout(function() {
					last = now;
					fn.apply(context, args);
				}, threshold);
			} else {
				last = now;
				fn.apply(context, args);
			}
		};
	};

	/**
	 * @desc executes the callback function after the cooldown period (timeout)
	 * for continuously occurring events such as user type in search field after user has stopped
	 * typing and wait for cooldown period (timeout) then fire the AJAX call
	 * @param callback
	 * @param timeout
	 */
	pub.debounce = function(callback, timeout) {
		timeout = timeout || 200;
		return function() {
			var scope = this;
			var args = arguments;
			if (debounce_refs.has(callback)) {
				clearTimeout(debounce_refs.get(callback));
			}
			debounce_refs.set(callback, setTimeout(function() {
				debounce_refs.delete(callback);
				callback.apply(scope, Array.prototype.slice.call(args));
			}, timeout));
		}();
	};

	pub.once = function(fn, context) {
		var result;
		return function() {
			if (fn) {
				result = fn.apply(context || this, arguments);
				fn = null;
			}
			return result;
		};
	};

	pub.get_altered_url = function(p_new) {
		var get_string = document.location.search.substr(1);
		var p_final = {};
		if (get_string !== '') {
			var get_array = get_string.split('&');
			var get_name;
			var get_value;
			for (var i in get_array) {
				if (get_array.hasOwnProperty(i)) {
					var tmp = get_array[i].split('=');
					get_name = tmp[0];
					get_value = tmp[1];
					if (get_name in p_new) {
						if (p_new[get_name] !== null && p_new[get_name] !== undefined) {
							p_final[get_name] = p_new[get_name]; // overwrite
						}
						delete p_new[get_name];
					} else {
						p_final[get_name] = get_value; // unchanged
					}
				}
			}
		}

		for (var name_tmp1 in p_new) {
			if (p_new[name_tmp1] !== null && p_new[name_tmp1] !== undefined) {
				p_final[name_tmp1] = p_new[name_tmp1]; // add
			}
		}

		var p_final_array = [];
		for (var name_tmp2 in p_final) {
			if (typeof p_final[name_tmp2] === 'string') {
				p_final[name_tmp2] = p_final[name_tmp2].replace('&', '%26');
			}
			p_final_array.push(name_tmp2 + '=' + p_final[name_tmp2]); // maybe safer to use encodeURIComponent?
		}

		var new_url = document.location.protocol + '//' + document.location.host + document.location.pathname;
		if (p_final_array.length) {
			new_url += '?' + p_final_array.join('&');
		}
		return new_url;
	};

	pub.get_isset = function(name) {
		var url = new URL(window.location.href);
		return url.searchParams && url.searchParams.get(name) !== null;
	}

	pub.get_get = function(name) {
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
		var results = regex.exec(location.search);
		if (results === null && location.hash.search('_suid=') !== -1) {
			var regex_html4 = new RegExp("[\\?&#]" + name + "=([^&#]*)");
			results = regex_html4.exec(location.hash);
		}
		return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	};

	pub.set_get = function(p_new, remember, reload, state) {
		remember = remember || false;
		reload = reload || false;
		var new_url = pub.get_altered_url(p_new);
		if (remember) {
			if (reload || !window.history.pushState) {
				yalwa.basics.navigate(new_url);
			} else {
				window.history.pushState(state, null, new_url);
			}
		} else if (window.history.replaceState) {
			window.history.replaceState(state, null, new_url);
		}
	};

	pub.ss_set = function(key, value, expire) {
		expire = expire || false;
		return s_set(key, value, 'sessionStorage', expire);
	};
	pub.ls_set = function(key, value, expire) {
		expire = expire || false;
		return s_set(key, value, 'localStorage', expire);
	};
	pub.ss_remove = function(key) {
		return s_remove(key, 'sessionStorage');
	};
	pub.ls_remove = function(key) {
		return s_remove(key, 'localStorage');
	};
	pub.ss_get = function(key, is_object) {
		return s_get(key, is_object, 'sessionStorage');
	};
	pub.ls_get = function(key, is_object) {
		return s_get(key, is_object, 'localStorage');
	};
	function ls_flush() {
		if (arguments.length > 0) {
			yalwa.basics.sentry.submit_error(new Error('potential incorrect usage of ls_flush'));
			return;
		}
		const keep = [];
		jQuery([
			['forbid_app_rating', false],
			['uac', true],
			['uac_u', false],
			['interested', true],
			['dismissed_app_download', false],
			['uac_reset', false],
			['regs', true],
			['seen_swipe_hint', false],
			['send_on_enter', false],
			['last_areaID', false],
			['seen_with_dol_account', false],
			['dol_login_helper_seen_times', false],
			['dol_login_helper_DNS', false],
			['dol_app_promo_viewed_times', false],
			['dol_app_promo_do_not_show', false],
			['dol_reaction_count', false],
			['seen_swipe_guide', false],
			['track_jumpoff', false],
			['track_jumpoff_last_ts', false],
			[yalwa.dol.get_wow_new_icon_ls_key(), true],
			[yalwa.dol.get_seen_wow_tp_on_duel_ls_key(), true],
		]).each(function(i, config) {
			keep.push([config[0], pub.ls_get(config[0], config[1])]);
		});
		if (window.localStorage && window.localStorage.clear) {
			localStorage.clear();
			sessionStorage.clear();
		}
		for (let i = 0; i < keep.length; i++) {
			pub.ls_set(keep[i][0], keep[i][1]);
		}
	}
	function cookie_flush() {
		const remove = ['show_premium_renew_toaster'];
		jQuery(remove).each(function (key, value) {
			yalwa.basics.set_cookie(value, 0, -1);
		});
		
	}

	function s_set(key, value, type, expire) {
		if (!navigator.cookieEnabled) {
			return;
		}
		try {
			window[type].setItem(key, typeof(value) === 'object' ? JSON.stringify(value) : value);
			if (expire) {
				window[type].setItem(key + expiration_suffix, expire);
			}
			return true;
		} catch (e) {
			// QuotaExceededError
			//   chrome/safari      firefox
			if (e.code === 22 || e.code === 1014) {
				try {
					window[type].clear();
				}
				finally {
					try {
						window[type].setItem(key, typeof(value) === 'object' ? JSON.stringify(value) : value);
						if (expire) {
							window[type].setItem(key + expiration_suffix, expire);
						}
						return true;
					} catch (e) {
						if (location.port) {
							console.log(e.message);
						}
					}
				}
			}
			if (location.port) {
				console.log(e.message);
			}
		}
	}

	function s_remove(key, type) {
		try {
			window[type].removeItem(key);
			window[type].removeItem(key + expiration_suffix);
			return true;
		} catch (e) {
			//yalwa.basics.sentry.submit_error(new Error(e.message));
			return false;
		}
	}

	function s_get(key, is_object, type) {
		try {
			if (window[type].getItem(key + expiration_suffix)) {
				var expiration_ts = parseInt(window[type].getItem(key + expiration_suffix));
				if (expiration_ts < pub.unix()) {
					s_remove(key, type);
					return null;
				}
			}

			var value = window[type].getItem(key);
			if (value === 'true') {
				return true;
			} else if (value === 'false') {
				return false;
			} else if (value === 'null') {
				return null;
			}
			if (is_object) {
				value = JSON.parse(value);
			}
			return value;
		} catch (e) {
			//yalwa.basics.sentry.submit_error(new Error(e.message));
			return null;
		}
	}

	pub.toast = function(config) {
		if (typeof(config) !== 'object') {
			yalwa.basics.sentry.submit_error(new Error('wrong toastr usage'));
		}
		provide_toastr()
			.done(do_toast.bind(undefined, config));
	};

	pub.toast_success = function(message) {
		pub.toast({
			message: message,
			type: 'success',
			progressBar: true,
			positionClass: "toast-top-full-width",
			timeOut: 5000,
			"closeButton": true,
		});
	};

	pub.label_clear_cache = function() {
		try {
			Object.keys(localStorage).forEach(function(key) {
				if (/lang_/.test(key)) {
					localStorage.removeItem(key);
				}
			});
			return true;
		} catch (e) {
			//yalwa.basics.sentry.submit_error(new Error(e.message));
			return false;
		}
	};

	pub.label_cache = function(label, file) {
		return pub.ls_get(ls_lang_key(label, file || 'main'));
	};

	pub.labels = function(labels_wanted) {
		check_svn_revision();
		var deferred;
		var values = {};
		var requests = [];
		for (var i = 0; i < labels_wanted.length; i++) {
			var label_key = labels_wanted[i].label;
			var file = labels_wanted[i].file || 'main';

			var ls_value = pub.ls_get(ls_lang_key(label_key, file));
			if (ls_value === null) {
				requests.push({
					label: label_key,
					file: file
				});
			} else {
				values[label_key] = ls_value;
			}
		}
		if (requests.length) {
			deferred = request_labels(requests, false, values);
		} else {
			deferred = jQuery.Deferred();
			deferred.resolve(values);
		}

		return deferred.promise();
	};

	pub.label = function(label_key, file) {
		check_svn_revision();
		file = file || 'main';
		var deferred;
		var ls_value;
		if (yalwa.v.lang && yalwa.v.lang[label_key]) {
			ls_value = yalwa.v.lang[label_key];
		} else {
			ls_value = pub.ls_get(ls_lang_key(label_key, file));
		}

		if (ls_value === null) {
			deferred = request_labels([{label: label_key, file: file}], true);
		} else {
			deferred = jQuery.Deferred();
			deferred.resolve(ls_value);
		}
		return deferred.promise();
	};

	// only used by cordova, webpush are tracked in sw.js
	pub.track_pn_received = function(typeID, device_typeID, variationID, cordova_deviceID) {
		track('received', typeID, device_typeID, variationID, cordova_deviceID);
	};

	// only used by cordova, webpush are tracked in sw.js
	pub.track_pn_clicked = function(typeID, device_typeID, variationID, cordova_deviceID) {
		track('clicked', typeID, device_typeID, variationID, cordova_deviceID);
	};

	function track(action, typeID, device_typeID, variationID, cordova_deviceID) {
		if (yalwa.basics.tracking_quota_add_and_check()) {
			return;
		}
		const url = '/api/ajax/pn_tracker/';
		const data = {
			action: action,
			typeID: typeID,
			device_typeID: device_typeID
		};
		if (variationID) {
			data.variationID = variationID;
		}
		if (cordova_deviceID) {
			data.cordova_deviceID = cordova_deviceID;
		}
		yalwa.basics.beacon(url, data);
	}

	pub.upload_type_regex = function(allow_pdf = false) {
		return allow_pdf ? (/((\.|\/)(gif|jpe?g|png|pdf)|data:image\/jpeg;base64,)$/i) : (/((\.|\/)(gif|jpe?g|png)|data:image\/jpeg;base64,)$/i);
	};

	pub.show = function($element) {
		if ($element && $element.length) {
			return $element.removeClass('hidden');
		}
	};

	pub.hide = function($element) {
		if ($element && $element.length) {
			return $element.addClass('hidden');
		}
	};

	pub.toggle = function($element, bool) {
		if (bool === undefined) {
			if ($element.hasClass('hidden')) {
				return pub.show($element);
			} else {
				return pub.hide($element);
			}
		} else {
			if (bool) {
				return pub.show($element);
			} else {
				return pub.hide($element);
			}
		}
	};

	pub.static_url = function(type) {
		const static_url = yalwa.v.static_url;
		if (static_url) {
			switch (type) {
				case 'images':
					return static_url + '/images/';
				case 'svg':
					return static_url + '/images/bg/svg/';
				case 'js':
					return static_url + '/js/';
				case 'css':
					return static_url + '/styles/';
				default:
					yalwa.basics.sentry.submit_error(new Error(`invalid type ${type} given for static url`));
					break;
			}
		}
		yalwa.basics.sentry.submit_error(new Error(`invalid static_url value: ${static_url}`));
	};

	pub.import_js = async function(path) {
		const url = await resolve_asset_url(yalwa.basics.static_url('js') + path);
		return import(url);
	};

	function progress_load() {
		var deferred = jQuery.Deferred();
		if (progress_is_loaded()) {
			deferred.resolve();
		} else {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/nprogress.js', function() {
				deferred.resolve();
			});
		}
		return deferred.promise();
	}

	function progress_is_loaded() {
		return typeof(window.NProgress) !== 'undefined';
	}

	function progress_start(name, settings) {
		name = name || 'single';
		progress_load().done(function() {
			settings = settings || {};
			yalwa.v.progress = yalwa.v.progress || {};
			if (yalwa.v.progress[name]) {
				progress_stop(name);
			}
			if (window.NProgress) {
				yalwa.v.progress[name] = new window.NProgress();
				yalwa.v.progress[name].configure(settings);

				yalwa.v.progress[name].start();
			}
		});
	}

	function progress_is_started(name) {
		return yalwa.v.progress && yalwa.v.progress[name];
	}

	function progress_set(name, value) {
		name = name || 'single';
		if (yalwa.v.progress && yalwa.v.progress[name]) {
			yalwa.v.progress[name].set(value);
		}
	}

	function progress_stop_error(name) {
		name = name || 'single';
		if (yalwa.v.progress[name]) {
			yalwa.v.progress[name].error();
		}
		progress_stop(name);
	}

	function progress_stop(name) { // beware: used via cordova
		name = name || 'single';
		progress_load().done(function() {
			if (yalwa.v.progress && typeof(yalwa.v.progress[name]) !== 'undefined') {
				progress_load().done(function() {
					yalwa.v.progress[name].done();
					delete yalwa.v.progress[name];
				});
			}
		});
	}

	function provide_toastr() {
		var deferred = jQuery.Deferred();
		if (toastr_loaded()) {
			deferred.resolve();
		} else {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/toastr.min.js', function() {
				if (toastr_loaded()) {
					deferred.resolve();
				} else {
					deferred.reject();
				}
			});
		}
		return deferred.promise();
	}

	function toastr_loaded() {
		return typeof(window.toastr) !== 'undefined';
	}

	function do_toast(config) {
		config.showDuration = config.showDuration || 0;
		config.hideDuration = config.hideDuration || 250;
		config.customClass = config.customClass || '';
		config.positionClass = config.positionClass || 'toast-top-full-width';

		if (!toastr_loaded()) {
			if (location.port) {
				yalwa.basics.sentry.submit_error(new Error('unable to load toastr'));
			}
		} else {
			if (typeof(window.toastr[config.type]) === 'function') {
				if (config.maxCount) {
					if (window.toastr.count === undefined) {
						window.toastr.count = 1;
					}
					window.toastr.subscribe(function(arg) {
						if (arg.state === 'visible') {
							window.toastr.count++;
						} else {
							window.toastr.count--;
						}
					})
					var maxCount = config.maxCount;
					if (window.toastr.count > maxCount) {
						return false;
					}
				}
				var $toast = window.toastr[config.type].call(undefined, config.message || '', config.title || '', config);
				var classes_tmp = config.customClass + ' toast_mobile';
				var icon_names = {
					'error': 'toast--error_warn',
					'info': 'toast--info',
					'success': 'toast--success',
					'warning': 'warning--white',
				};
				let icon_folder = yalwa.v.is_dol ? 'dol': 'main';
				if ($toast) {
					if(config.customButton && config.customButton.selfClass && config.customButton.action) {
						$toast.delegate(config.customButton.selfClass, 'click', function () {
							//Triggering the action of Custom button (Should be a method)
							config.customButton.action();
						});
					}
					$toast.prepend(yalwa.basics.yicon(icon_names[config.type],{classes: 'toastr__yicon', folder: icon_folder, pixel: 18}));
				}
			}
		}
	}

	function ls_lang_key(label_key, file) {
		return 'lang_' + file + '_' + label_key;
	}

	pub.label_set = function(label, file, value) {
		pub.ls_set(ls_lang_key(label, file), value);
	};

	function request_labels(labels, single_mode, values) {
		return jQuery.ajax({
			url: '/api/ajax/general/',
			data: {
				action: 'request_labels',
				labels: labels,
				single_mode: single_mode ? 1 : 0
			},
			dataType: single_mode ? 'text' : 'json'
		}).then(function(response) {
			if (single_mode) {
				if (response) {
					pub.label_set(labels[0].label, labels[0].file, response);
					return response;
				} else {
					yalwa.basics.sentry.submit_error(new Error('tried to request invalid language key "' + labels[0].key + '" in file "' + labels[0].file + '"'));
				}
			} else {
				values = values || {};
				for (var label_tmp in response) {
					if (response.hasOwnProperty(label_tmp)) {
						if (response[label_tmp].value) {
							pub.label_set(label_tmp, response[label_tmp].file, response[label_tmp].value);
						}
						values[label_tmp] = response[label_tmp].value;
					}
				}
				return values;
			}
		});
	}

	pub.get_svn_revision = function() {
		if (yalwa.v.fingerprint) {
			return yalwa.v.fingerprint || '';
		}
		yalwa.basics.sentry.submit_error(new Error(`invalid fingerprint value in get_svn_revision: ${yalwa.v.fingerprint}`));
	};

	function check_svn_revision() {
		const svn_revision_cache = pub.ls_get('svn_revision');
		const svn_revision = yalwa.basics.get_svn_revision();
		if (svn_revision_cache && svn_revision_cache !== svn_revision) {
			pub.label_clear_cache();
			pub.ls_set('svn_revision', svn_revision);
		}
	}

	pub.progress = {
		load: progress_load,
		start: progress_start,
		stop: progress_stop, // beware: used via cordova
		set: progress_set,
		error: progress_stop_error,
		is_started: progress_is_started
	};

	pub.language = function() {
		if (yalwa.v.language) {
			return yalwa.v.language;
		}
		yalwa.basics.sentry.submit_error(new Error('no values set for yalwa.v.language ' + yalwa.v.language));
		return jQuery('html').data('language');
	};
	
	let dayjs_deferred_promise;
	let dayjs;
	pub.load_dayjs = function() {
		if (!dayjs_deferred_promise) {
			const dayjs_deferred = jQuery.Deferred();
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'shared/modules/day_oldbrowsers.js').then(() => {
				Dayjs.load().done(() => {
					dayjs = Dayjs;
					dayjs_deferred.resolve(Dayjs);
				});
			});
			dayjs_deferred_promise = dayjs_deferred.promise();
		}
		return dayjs_deferred_promise;
	};
	
	//https://stackoverflow.com/a/60463819/333864
	function hasDynamicImport() {
		try {
			return new Function("return import('data:text/javascript;base64,Cg==').then(r => true)")();
		} catch(e) {
			return Promise.resolve(false);
		}
	}
	
	pub.dayjs = () => {
		return dayjs;
	};

	pub.chrome_version = function() { // http://stackoverflow.com/a/4900484/333864
		var raw = navigator.userAgent.match(/(Chrom(e|ium)|CriOS)\/([0-9]+)\./);
		return raw ? parseInt(raw[3], 10) : false;
	};

	// careful - this method is used in external/fileupload.js ...
	pub.safari_version = function() {
		let result = false;
		let raw = navigator.userAgent.match(/Version\/([0-9]+).*Safari/) ||
			navigator.userAgent.match(/Safari\/([0-9]+)/) ||
			navigator.userAgent.match(/AppleWebKit\/([0-9]+).*YalwApp/);
		result = raw ? parseInt(raw[1], 10) : false;
		return result;
	};

	pub.clone_absolute = function($to_clone) {
		const $clone = $to_clone.clone();
		jQuery('body').append($clone);
		const left = $to_clone.offset().left;
		$clone.css({top: $to_clone.offset().top, left: left, position: 'absolute', 'zIndex': 10});
		return $clone;
	};
	
	pub.yimage = function(name, o) {
		o = o || {};
		if (!name) {
			yalwa.basics.sentry.submit_error_with_options(new Error('yimage call without name'), {extra: {object: o}});
			return '';
		}
		o.classes = o.classes ? `yimage yicon ${o.classes}` : 'yimage yicon';
		o = jQuery.extend({
			pixel: 16,
			folder: 'dol',
			classes: 'yimage yicon',
			site: 'mobile',
			data: {},
			title: '',
			alt: ''
		}, o);
		let data_string = '';
		const data_keys = Object.keys(o.data);
		if (data_keys.length) {
			data_keys.map(data_key => {
				data_string += ` data-${data_key}="${o.data[data_key]}"`;
			})
		}
		let title_string = '';
		if (o.title) {
			title_string = ' title="' + o.title + '"';
		}
		let alt_string = '';
		if (o.alt) {
			alt_string = ' alt="' + o.alt + '"';
		}
		let _return =  `<img src="${yalwa.v.static_url}/images/bg/icons/svg/mobile/${o.folder}/${name}.svg" class="${o.classes}" width="${o.pixel}" height="${o.pixel}"${data_string}${title_string}${alt_string}>`;
		//console.log(_return);
		return _return;
	}
	
	pub.yimage_toggle = function($element, icon_primary, icon_alternate) {
		const src = $element.attr('src');
		const new_icon = src.includes(icon_primary) ? icon_alternate : icon_primary;
		pub.yimage_change(new_icon, $element);
	}
	
	pub.yicon_toggle = function($element, first_icon_name, second_icon_name) {
		if (yalwa.v.yimage_active) {
			pub.yimage_toggle($element, first_icon_name, second_icon_name);
			return;
		}
		const class_name = yicon_modifier_get($element);
		const replaced_name = class_name.includes(first_icon_name) ? first_icon_name : second_icon_name;
		const with_name = class_name.includes(first_icon_name) ? second_icon_name : first_icon_name;
		const new_class_name = class_name.replace(replaced_name, with_name);
		$element.toggleClass(`${class_name} ${new_class_name}`);
	}
	
	pub.yicon_change = function(new_name, $element) {
		if (yalwa.v.yimage_active) {
			pub.yimage_change(new_name, $element);
			return;
		}
		const existing_class = yicon_sprite_get($element);
		const sprite_part = extract_sprites_mobile_part(existing_class);
		$element.removeClass(existing_class).addClass(`${sprite_part}${new_name}`);
	}
	
	function yicon_sprite_get($element) {
		var bem_class;
		let cl = $element.attr('class');
		if (cl) {
			jQuery.each(cl.split(' '), (i, name) => {
				if (!bem_class && name.indexOf('js-') !== 0 && name.indexOf('__') !== -1) {
					bem_class = name;
				}
			});
		}
		return bem_class ?? null;
	}
	
	function extract_sprites_mobile_part(input_string) {
		const regex = /^(sprites_mobile_.*?__)/;
		const match = input_string.match(regex);
		return match && match[1] ? match[1] : null;
	}

	pub.yicon = function(name, o) {
		if (yalwa.v.yimage_active) {
			return yalwa.basics.yimage(name, o);
		}
		o = jQuery.extend({
			pixel: 16,
			folder: 'dol',
			classes: '',
			site: 'mobile'
		}, o);
		var data_string = '';
		if (o.data) {
			var data = [];
			for (var i in o.data) {
				data.push('data-' + i + '="' + o.data[i] + '"');
			}
			data_string += ' ' + data.join(' ');
		}
		var title_string = '';
		if (o.title) {
			title_string = ' title="' + o.title + '"';
		}
		return '<div style="width:' + o.pixel + 'px;height:' + o.pixel + 'px;" class="yicon sprites_' + o.site + '_' + o.folder + '__' + name + ' ' + o.classes + '"' + data_string + title_string +'></div>';
	};

	pub.yif = function(name, o) {
		var font_class = 'yif';
		o = jQuery.extend({
			pixel: 16,
			name: 'flaticon',
			classes: '',
			suffix: 'mobile'
		}, o);
		var data_string = '';
		if (o.data) {
			var data = [];
			for (var i in o.data) {
				data.push('data-' + i + '="' + o.data[i] + '"');
			}
			data_string += ' ' + data.join(' ');
		}
		return '<i class="' + font_class + (o.pixel ? ' ' + font_class + '_' + o.pixel : '') + ' ' + o.name + '_' + o.suffix + ' ' + o.name + '-' + name + (o.classes ? ' ' + o.classes : '') + '"' + data_string + '></i>';
	};

	pub.image_upload_dimensions = function(file) {
		var deferred = jQuery.Deferred();
		if (file && window.URL && window.URL.createObjectURL) {
			var img = new Image();
			img.src = window.URL.createObjectURL(file);
			img.onload = function() {
				var w = img.naturalWidth;
				var h = img.naturalHeight;
				window.URL.revokeObjectURL(img.src);
				deferred.resolve({w: w, h: h});
			};
		} else {
			deferred.reject();
		}
		return deferred.promise();
	};

	pub.image_upload_ratio_check = function(file) {
		var deferred = jQuery.Deferred();
		pub.image_upload_dimensions(file).done(function(d) {
			if (d && d.w) {
				var ratio = Math.max(d.w, d.h) / Math.min(d.w, d.h);
				deferred.resolve(ratio > 10);
			} else {
				deferred.reject();
			}
		});
		return deferred.promise();
	};

	pub.linkify = function(text) {
		var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;äöü]*[-A-Z0-9+&@#\/%=~_|])/ig;
		return text.replace(urlRegex, linkify_helper);
	};

	function linkify_helper(url) {
		return '<a target="_blank" href="' + url + '">' + url + '</a>';
	}

	pub.normalize = function(text) {
		if (typeof(text.normalize) === 'function') {
			// http://stackoverflow.com/a/37511463
			text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
		}
		return text;
	};

	pub.unix = function(date) {
		return Math.floor((date || Date.now()) / 1000);
	};

	pub.login_url = function(params) {
		params = params || {};
		params.cid = params.cid || yalwa.v.cid || yalwa.v.countryID;
		params.aid = params.aid || yalwa.v.aid;
		params['continue'] = params['continue'] || encodeURI(location.href);
		var params_array = [];
		jQuery.each(params, function(name, value) {
			if (value !== undefined && value !== null) {
				params_array.push(name + '=' + value);
			}
		});
		return yalwa.v.accounts_url + 'login?' + params_array.join('&');
	};

	// careful: can be easily manipulated, don't user for sensitive stuff
	pub.is_logged_in = function() {
		return yalwa.v.is_logged_in;
	};

	pub.upload_max_file_size = function() {
		return 20000000; // 20MB
	};

	pub.yalwapp_version = function() {
		var matches = navigator.userAgent.match(get_cordova_app_detection_regex());
		if (matches && matches[1] && matches[2] && matches[3]) {
			if(matches[4]) {
				return parseInt(matches[1] + matches[2] + matches[3] + matches[4], 10);
			} else {
				return parseInt(matches[1] + matches[2] + matches[3], 10);
			}
		}
		return 0;
	};

	pub.upload_defaults = function() {
		return {
			dataType: 'json',
			disableImageResize: /Android(?!.*Chrome)|Opera/.test(window.navigator && navigator.userAgent),
			imageMaxWidth: 600,
			imageMaxHeight: 600,
			imageMinWidth: 1,
			imageMinHeight: 1,
			imageOrientation: true,
			imageQuality: .9,
			disableImageMetaDataSave: true,
			acceptFileTypes: yalwa.basics.upload_type_regex(),
			maxFileSize: pub.upload_max_file_size()
		};
	};

	pub.cordova_upload_blob = function(b64Data) { // beware: used via cordova version < 2.4.4
		yalwa.mobile.cordova.cordova_upload_blob(b64Data, 'data:image/jpeg;base64,');
	};

	pub.nav_started = function() {
		return nav_started;
	};
	
	pub.reload = function() {
		nav_started = true;
		window.location.reload();
	};

	pub.navigate = function(url) {
		if (!url) {
			yalwa.basics.sentry.submit_error(new Error ('invalid function call navigate without argument url'));
			return;
		}
		if (yalwa.mobile) {
			yalwa.mobile.page_will_unload(url);
		}
		nav_started = true;
		if (yalwa.v.promo_interstitial) {
			jQuery(document).trigger('navigate_away', url);
		} else {
			window.location.href = url;
		}
	};
	
	pub.is_valid_url = function(url_string) {
		try {
			new URL(url_string);
			return true;
		} catch (e) {
			return false;
		}
	}
	
	pub.create_profile_pic_url = function(image) {
		if (image && pub.check_if_profile_pic_url(image)) {
			return image;
		}
		//build the URL
		return image ? yalwa.v.init_settings.profile_pic_base_url + image : '';
	}
	
	pub.hide_all_plps = function() {
		jQuery('.js-plp').trigger('plp_hide');
	}
	
	pub.check_if_profile_pic_url = function(image) {
		if (image && yalwa.basics.is_valid_url(image)) {
			return image;
		}
		return false;
	}

	pub.new_tab = function(url) {
		if (url[0] === '/') {
			url = location.origin + url;
		}
		if (yalwa.v.is_phonegap) {
			yalwa.mobile.cordova.openexternal(url);
		} else {
			if (yalwa.basics.is_pwa()) {
				pub.navigate(url);
				return;
			}
			window.open(url, null, 'noopener');
		}
	};
	
	pub.beacon = function(url, data) {
		return new Promise((resolve, reject) => {
			let result = false;
			if(url.indexOf('api/ajax/track') !== -1) {
				data.pt = yalwa.v.pt;
			}
			if (navigator.sendBeacon) {
				let fd = new FormData();
				Object.keys(data).forEach(key => fd.append(key, data[key]));
				result = navigator.sendBeacon(url, fd);
			}
			
			if (result) {
				resolve(result);
			} else {
				jQuery.ajax({url: url, data: data, type: 'post'})
					.done(resolve)
					.fail(reject);
			}
		});
	};

	pub.connection = function() {
		const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
		let result = 'unknown';
		if (connection) {
			const connection_type = connection.hasOwnProperty('type') ? 'type' : 'effectiveType';
			result = connection[connection_type];
		}
		return result;
	};

	pub.get_routing = function() {
		yalwa.v.routing = yalwa.v.routing || jQuery('html').data('routing');
		return yalwa.v.routing;
	};

	pub.check_routing = function() {
		var routing = yalwa.basics.get_routing();
		switch (routing) {
			case 'account_activation':
				check_uac().done(function(cn) {
					if (yalwa.v.redirect && suspicious(cn)) {
						if (yalwa.basics.get_get('ctrlStr') && yalwa.v.redirect !== yalwa.basics.get_get('ctrlStr') && jQuery('#nickname').length) {
							yalwa.basics.set_get({ctrlStr: yalwa.v.redirect}, true, true);
						}
					}
				});
				break;
			case 'registration':
				init_registration_check();
				break;
			case 'change_email':
				if (yalwa.v.try_old_tip) {
					setTimeout(() => {
						yalwa.basics.load_tippy().done(() => {
							tippy('.js-change_email', {
								content: yalwa.v.try_old_tip,
								placement: 'top-end',
								maxWidth: 240,
								showOnCreate: true,
								trigger: 'click',
								interactive: true,
								hideOnClick: true
							});
						});
					}, 1000);
				}
		}
	};

	pub.supports_audio = function() {
		// if (yalwa.v.is_ios) {
		// 	return false;
		// }
		var a = document.createElement('audio');
		return !!(a.canPlayType && a.canPlayType('audio/mpeg;').replace(/no/, ''));
	};

	pub.gdpr_consent_given = function (consent_category) {
		if (!yalwa.v.gdpr_active) {
			// gdpr not necessary
			return true;
		}
		const settings_cookie = pub.get_cookie('gdpr_settings');
		// user should see the gdpr popup first
		if (!settings_cookie) {
			return false;
		}

		try {
			const settings = JSON.parse(unescape(decodeURI(settings_cookie)));
			return settings[consent_category];
		} catch (e) {
			// cookie does not contain valid JSON
			return false;
		}
	};

	pub.create_uuid = function() { // https://stackoverflow.com/a/8809472/333864
		if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
			return crypto.randomUUID();
		}
		var d = new Date().getTime();
		if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
			d += performance.now(); //use high-precision timer if available
		}
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = (d + Math.random() * 16) % 16 | 0;
			d = Math.floor(d / 16);
			return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
		});
	};

	pub.svg = (function(pub) {

		pub = pub || {};

		pub.create = function(name, options) {
			var classes = [];
			options = options || {};
			if (options['classes'] && Array.isArray(options['classes'])) {
				classes = classes.concat(options['classes']);
			}
			var mod = options['mod'] || ['16', 'greyblack'];
			classes = classes.concat(mod.map(function(modifier) {
				if(!isNaN(parseInt(modifier))) {
					return 'ysvg--' + modifier;
				} else {
					return 'yicon ysvg--' + modifier;
				}

			}));
			return '<img class="' + classes.join(' ') + '" alt="" src="' + yalwa.basics.static_url('svg') + name + '.svg">'
		};

		pub.create_sprite = function(name, options) {
			var svg_class = 'ysvg';
			var classes = [svg_class];
			options = options || {};
			options['pixel'] = options['pixel'] || 16;
			options['sprite_name'] = options['sprite_name'] || 'dol';
			if (options['classes'] && Array.isArray(options['classes'])) {
				classes = classes.concat(options['classes']);
			}
			var mod = options['mod'] || ['greyblack'];
			classes = classes.concat(mod.map(function(modifier) {
				return svg_class + '--' + modifier;
			}));

			return '<div style="width:' + options['pixel'] + 'px; height:' + options['pixel'] + 'px;" class="sprites_mobile_' + options['sprite_name'] + '__' + name +' yicon js-yicon ysvg--' + mod + ' ' + classes.join(' ') + '"></div>';
		};

		pub.get_id = function($element) {
			var url = get_url($element);
			if (!url) {
				return null;
			}
			var result = url.match(/#([A-Za-z_-]+)$/);
			if (!result || !result[1]) {
				return null;
			}
			return result[1];
		}

		pub.set_id = function($element, new_value) {
			var use = get_use($element);
			if (use) {
				use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', get_url($element).replace(/[^#]+$/, new_value));
			}
		}
		pub.lazyload = function($element) {
			var use = get_use($element);
			if (use) {
				use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', use.dataset.href);
			}
		};

		function get_use($element) {
			var $use = $element.children('use');
			return $use.length ? $use[0] : null;
		}

		function get_url($element) {
			var $use = get_use($element);
			if (!$use) {
				return null;
			}
			var url = $use.getAttributeNS('http://www.w3.org/1999/xlink', 'href');
			if (!url) {
				return null;
			}
			return url;
		}

		return pub;

	}(pub.svg));

	pub.state = (function(pub) {

		pub = pub || {};
		var current_state = ['init_dummy'];
		var pagepop_checks = {};
		var debug = false;

		pub.init = function() {
			// https://github.com/visionmedia/page.js/issues/213
			jQuery(document).ready(function() {
				setTimeout(function() {
					window.addEventListener('popstate', onpopstate);
				}, 100);
			});
		};

		// callback should include necessary dom-changes to apply when going back
		// return true if dom-change took place, otherwise false to proceed to next pop
		// arguments: state_from, state_to
		pub.register = function(id, callback) {
			pagepop_checks[id] = callback;
		};

		// reset virtual history
		pub.unregister = function() {
			current_state = ['init_dummy'];
			pagepop_checks = {};
		};

		pub.push = function(state, title, url) {
			title = title || null;
			url = url || window.location.href;
			if (typeof(state) === 'string') {
				state = {id: state};
			}
			if (debug) {
				console.log('%cpush:' + state.id, 'color:blue');
			}
			current_state.push(state);
			window.history.pushState(state, title, url);
			if(window.history.state && window.history.state.ltw_type === 'root') {
				if (yalwa.v.is_phonegap && yalwa.v.is_ios) {
					yalwa.mobile.cordova.remove_backbutton();
				}
			} else {
				if (yalwa.v.is_phonegap && yalwa.v.is_ios) {
					yalwa.mobile.cordova.activate_backbutton();
				}
			}
		};

		// probably not needed anymore
		pub.try_cancel = function(id) {
			if (history.state && history.state.id === id) {
				if (debug) {
					console.log('%ccancel success:' + id, 'color:red');
				}
				var s = state_current();
				if (s && typeof(s) === 'object') {
					s.cancelled = true;
				}
			} else {
				if (debug) {
					console.log('%ccancel fail: ' + id, 'color:red', history.state);
				}
			}
		};

		pub.back = function(is_swipe) {
			if (is_swipe) {
				setTimeout(function() {
					back();
					yalwa.basics.ls_set('last_page', null);
					jQuery('.js-main_col').velocity('transition.slideLeftBigIn', {duration: 250});
				}, 220);
			} else {
				back();
			}
			// if (back_till_real_pageview && state_current() !== 'init_dummy') {
			// 	setTimeout(function() {
			// 		pub.back(true);
			// 	}, 20);
			// }
		};

		pub.extend = function(params, no_url) {
			var updated_state = jQuery.extend(history.state, params);
			state_current_set(updated_state);
			history.replaceState(updated_state, null, no_url ? null : yalwa.basics.get_altered_url(params));
		};

		function state_current_set(value) {
			if (current_state.length) {
				current_state[current_state.length - 1] = value;
			}
		}

		function state_current() {
			return current_state.length ? current_state[current_state.length - 1] : null;
		}

		function back() {
			window.history.back();
		}

		pub.prevent_back_button_caching = function(url) {
			yalwa.basics.state.push({id:'prevented', state:'custom_handling', url: url}, null, window.location.href);
			yalwa.basics.state.push({id:'prevented', state:'prevent_back', url: url}, null, window.location.href);
			yalwa.basics.state.push({id:'prevented', state:'prevent_forward', url: url}, null, window.location.href);
			history.back();
			history.forward();
		};

		function onpopstate(e) {
			var s = state_current();

			if (s && s.id) {
				if(s.id === 'prevented') {
					switch (s.state) {
						case 'prevent_forward':
							current_state.pop();
							history.go(1);
							return;
							break;
						case 'prevent_back':
							current_state.pop();
							return;
							break;
						case 'custom_handling':
							yalwa.basics.navigate(s.url);
							return;
							break;
					}
				}
			}
			current_state.pop();
			if (s && s.id) {
				if(s.step) {
					//console.log(s.step)
					return;
				} else if (s.cancelled) {
					if (debug) {
						console.log('%ccancelled: ' + s.id, 'color:purple');
					}
					back();
					return;
				}
				var visible_dom_change = pagepop_checks[s.id] && pagepop_checks[s.id](s, state_current());
				if (visible_dom_change) {
					if (debug) {
						console.log('%cvisible dom change applied: ' + s.id, 'color:green');
					}
				} else {
					if (debug) {
						console.log('%cno visible dom change, proceeding: ' + s.id, 'color:purple');
					}
					back();
				}
			} else {
				if (debug) {
					console.log('%cno state, proceeding: ', 'color:purple');
				}
				//  BOF DEV-987
				if(['terms', 'privacy', 'dol_onboarding'].indexOf(yalwa.basics.get_routing()) !== -1){
					//  EOF DEV-987
				} else if ((!yalwa.faq && !yalwa.paf && !location.hash && !yalwa.v.is_ios && !yalwa.v.is_phonegap) || ['settings', 'dol_onboarding'].indexOf(yalwa.basics.get_routing()) !== -1) {
					back();
				}
			}
		}

		return pub;
	}(pub.state));

	pub.sentry = ((pub = {}) => {

		pub.submit_error = err => {
			if (location.port) {
				console.error(err);
			}
			if (!window.yalwa || !yalwa.v) {
				// something is completely broken, errors will just be symptoms
				return false;
			}
			if(typeof Sentry === 'undefined' || !err) {
				return false;
			}
			Sentry.captureException(err);
		};
		
		pub.submit_error_with_options = (err, options) => {
			if (typeof err === 'string') {
				err = new Error(err);
			}
			options = options || {};
			if (location.port) {
				console.error(err);
			}
			if (!window.yalwa || !yalwa.v) {
				// something is completely broken, errors will just be symptoms
				return false;
			}
			if (typeof Sentry === 'undefined' || !err) {
				return false;
			}
			Sentry.captureException(err, {
				contexts: {
					customdata: options.extra,
				},
			});
		}
		
		return pub;

	})(pub.sentry);

	pub.ga = (function(pub) {

		pub = pub || {};
		let dimensions = {};
		let metrics = {};
		let debug;

		pub.init = function() {
			debug = location.port && yalwa.basics.get_get('log_ga');
			if (yalwa.basics.get_routing() === 'demo') {
				return;
			}
			if (!window.dataLayer) {
				return;
			}
			if (!yalwa.v.gtag_init) {
				return;
			}
			yalwa.v.gtag_init.sampling_is_tracked = tracked_in_ga4();
			if(check_optout()) {
				return;
			}
			if (yalwa.v.ga_disabled) {
				datalayer_push({event: 'ga_disabled'});
			}
			set_initial_ga_metrics();
			set_initial_ga_dimensions();
			const config = {
				'userID': yalwa.v.gtag_init.user || null,
				'appName': yalwa.v.gtag_init.appName,
				'sampling_is_tracked': yalwa.v.gtag_init.sampling_is_tracked
			};
			jQuery.each(dimensions, function(i, e) {
				config[i] = e;
			});
			datalayer_push({event: 'ga_config', data: config});
			if (debug) {
				console.log('%cpageview', 'color: blue', JSON.parse(JSON.stringify(config)));
			}
			jQuery('.js-click_tracker').on('click', click_tracker_on_click);
			jQuery('.js-view_tracker').each(view_tracker_on_view);
		};
		
		function tracked_in_ga4() {
			let sample = yalwa.basics.get_cookie('ga4_sample'); // try cookie first
			if (sample === null || sample === false) { // maybe localStorage still has a previous value
				sample = yalwa.basics.ls_get('ga4_sample');
			}
			if (sample === null || sample === false) { // no previous info, generate random new one
				sample = Math.floor(Math.random() * 100);
			}
			
			// sync current values across both cookie and LS
			yalwa.basics.ls_set('ga4_sample', sample);
			yalwa.basics.set_cookie('ga4_sample', sample, 10 * yalwa.basics.ONE_YEAR);
			
			return parseInt(sample, 10) < 10;
		}
		
		function datalayer_push(data) {
			if (location.port) {
				let history = yalwa.basics.ls_get('GA_history', true) || [];
				history.push(jQuery.extend(data, {unix: yalwa.basics.unix(), url: location.href}));
				const max = 10;
				if (history.length > max) {
					history = history.slice(history.length - max, history.length);
				}
				yalwa.basics.ls_set('GA_history', history);
				jQuery(document).trigger('GA_history_change');
			}
			yalwa.basics.datalayer_push(data);
		}
		
		pub.consent_granted = function() {
		};
		
		function flip(object){
			let ret = {};
			for(let key in object){
				ret[object[key]] = key;
			}
			return ret;
		}
		
		function get_mapped_metrics(flipped = false) {
			if (flipped) {
				return flip(yalwa.v.gtag_init.metric_names);
			} else {
				return yalwa.v.gtag_init.metric_names;
			}
		}

		function get_mapped_dimensions(flipped = false) {
			if (flipped) {
				return flip(yalwa.v.gtag_init.dimension_names);
			} else {
				return yalwa.v.gtag_init.dimension_names;
			}
		}

		pub.ping_metric = function(metric, value) {
			if (pub.metric_set(metric, value)) {
				pub.event({category: 'custom_metric', action: metric, label: value});
				pub.metric_unset(metric);
			}
		};

		pub.event = function(details) {
			if (debug) {
				console.log('%cevent', 'color: green', JSON.parse(JSON.stringify(details)));
			}
			const deferred = jQuery.Deferred();
			if (yalwa.v.ga_disabled) {
				return deferred.reject().promise();
			}
			if (!details.category || !details.action) {
				yalwa.basics.sentry.submit_error(new Error('invalid ga event tracking, category: ' + details.category + ' action: ' + details.action));
				return deferred.reject().promise();
			}

			if (typeof details.action != 'string') {
				console.log('GA Event action value type needs to be string instead of ' + typeof details.action + ' for event category ' + details.category);
			}

			before_ping();
			// console.log('%cevent', 'color: green', details.action, JSON.parse(JSON.stringify(details_final)));
			datalayer_push({
				'event': 'eventTracking',
				'category': details.category,
				'action': details.action,
				'label': details.label,
				'value': details.value,
				'eventTimeout': 2000,
				'eventCallback': () => {
					deferred.resolve('success');
				}
			});
			after_ping();
			return deferred.promise();
		};

		pub.pageview = function(settings) {
			if (debug) {
				console.log('%cpageview', 'color: blue', JSON.parse(JSON.stringify(settings)));
			}
			if (yalwa.v.ga_disabled) {
				return false;
			}
			settings = settings || {};
			let s = jQuery.extend({}, dimensions, metrics);
			if (settings.location) {
				s.page_location = settings.location;
			}
			if (settings.page) {
				s.page_path = settings.page;
			}
			before_ping();
			// console.log('%cpageview', 'color: blue', JSON.parse(JSON.stringify(s)));
			datalayer_push({
				event: 'artifical_pageview',
				settings: settings
			});
			after_ping();
			DEV_9572_increase();
		};

		function before_ping() {

		}

		function after_ping() {
			pub.metric_unset('all');
		}

		pub.dimension_get = (dimension) => {
			if (!yalwa.v.gtag_init || !yalwa.v.gtag_init.dimension_names) {
				return null;
			}
			const integer = yalwa.v.gtag_init.dimension_names[dimension];
			if (!integer) {
				yalwa.basics.sentry.submit_error(new Error('Tried to get invalid custom dimension: "' + dimension + '"'));
				return null;
			} else {
				return dimensions['dimension' + integer];
			}
		};

		pub.dimension_set = function(dimension, value) {
			const integer = yalwa.v.gtag_init.dimension_names[dimension];
			if (!integer) {
				yalwa.basics.sentry.submit_error(new Error('Tried to set invalid custom dimension: "' + dimension + '" / "' + value + '"'));
			} else {
				if (value === null) {
					delete dimensions['dimension' + integer];
				} else {
					dimensions['dimension' + integer] = value;
				}
			}
		};

		pub.dimension_unset = function(dimension) {
			pub.dimension_set(dimension, null);
		};

		pub.metric_set = function(metric, value) {
			if (yalwa.v.gtag_init.metric_names[metric]) {
				if (value === null) {
					delete metrics['metric' + yalwa.v.gtag_init.metric_names[metric]];
				} else {
					metrics['metric' + yalwa.v.gtag_init.metric_names[metric]] = value;
					datalayer_push({
						event: 'custom_metric',
						metric: metric,
						value: value,
					});
				}
				return true;
			} else {
				yalwa.basics.sentry.submit_error(new Error('Tried to set invalid custom metric: "' + metric + '" / "' + value + '"'));
				return false;
			}
		};

		pub.metric_unset = function(metric) {
			if (metric === 'all') {
				const flipped = get_mapped_metrics(true);
				for(const id in metrics) {
					pub.metric_set(flipped[id.match(/[0-9]+/)[0]], null);
				}
			} else if (jQuery.isArray(metric)) {
				jQuery(metric).each(function(i, e) {
					pub.metric_set(e, null);
				});
			} else {
				pub.metric_set(metric, null);
			}
		};

		pub.optout = function() {
			yalwa.basics.ls_set('ga_optout', true);
		};
		
		function click_tracker_on_click() {
			const $this = jQuery(this);
			yalwa.basics.ga.event({category: $this.data('d1'), action: $this.data('d2'), label: $this.data('d3')});
		}

		function view_tracker_on_view() {
			const $this = jQuery(this);
			yalwa.basics.ga.event({category: $this.data('d1-view') || $this.data('d1'), action: $this.data('d2-view') || $this.data('d2'), label: $this.data('d3-view') || $this.data('d3')});
		}

		function check_optout() {
			if (yalwa.basics.ls_get('ga_optout')) {
				if (yalwa.v.ga_id) {
					window['ga-disable-' + yalwa.v.ga_id] = true;
				}
				return true;
			}
			return false;
		}

		function set_initial_ga_metrics() {
			const flipped = get_mapped_metrics(true);
			for(const id in yalwa.v.gtag_init.metrics) {
				if (yalwa.v.gtag_init.metrics.hasOwnProperty(id)) {
					pub.metric_set(flipped[id], yalwa.v.gtag_init.metrics[id]);
				}
			}
		}

		function set_initial_ga_dimensions() {
			const flipped = get_mapped_dimensions(true);
			for(const id in yalwa.v.gtag_init.dimensions) {
				if (yalwa.v.gtag_init.dimensions.hasOwnProperty(id)) {
					if (!flipped[id]) {
						yalwa.basics.sentry.submit_error(new Error('Failed to find custom dimension: "' + id + '"'));
					} else {
						pub.dimension_set(flipped[id], yalwa.v.gtag_init.dimensions[id]);
					}
				}
			}
			if (yalwa.basics.is_pwa() && yalwa.basics.app_type() === 'browser') {
				pub.dimension_set('CD_DOL_APPTYPE', yalwa.basics.sw.name() === 'sw_dol.js' ? 'standalone_dating' : 'standalone');
			}
		}

		return pub;

	}(pub.ga));

	function not_working_email_provider_check(email) {
		if (yalwa.v.not_working_providers) {
			var not_working_provider = false;
			jQuery.each(yalwa.v.not_working_providers, function(index, provider) {
				if (email.toLowerCase().indexOf(provider.toLowerCase()) !== -1) {
					not_working_provider = provider;
				}
			});
			if (not_working_provider) {
				return not_working_provider.replace('.', '');
			} else {
				return false;
			}
		}
		return false;
	}

	function init_registration_check() {
		var $form = jQuery('.js-register_form');
		var check_complete = false;

		$form.on('submit', function(e) {
			var not_working_provider = not_working_email_provider_check(jQuery('.js-register_email').val());
			if (not_working_provider) {
				var $info = jQuery('.js-provider_not_working_error');
				if (!yalwa.v.provider_not_available_message) {
					yalwa.v.provider_not_available_message = $info.html();
				}
				var message = yalwa.v.provider_not_available_message.replace('%1$s', not_working_provider);
				$info.html(message);
				jQuery('.js-provider_not_working_plp .plp__text').html(message);
				jQuery('.js-provider_not_working_plp').trigger('plp_show');

				e.preventDefault();
				return false;
			}

			if ($form[0].checkValidity() === false || check_complete) {
				if (check_complete) {
					var regs = yalwa.basics.ls_get('regs', true) || [];
					regs.push(yalwa.basics.unix());
					yalwa.basics.ls_set('regs', regs);
				}
				return true;
			}
			e.preventDefault();
			check_uac().done(function(cn) {
				if (jQuery('.js-register_auth').length && !suspicious(cn)) {
					jQuery.ajax({
						method: "GET",
						url: '/api/ajax/register_auth/',
						data: {email: jQuery('.js-register_email').val()}
					}).done(function(ctrlStr) {
						jQuery('.js-register_auth').val(ctrlStr);
						check_complete = true;
						$form.submit();
					}).fail(function() {
						check_complete = true;
					});
				} else {
					check_complete = true;
					$form.submit();
				}
			})
		});
	}

	function ls_disabled() {
		let key = 'ls_support_' + yalwa.basics.unix();
		yalwa.basics.ls_set(key, true);
		let support = yalwa.basics.ls_get(key) === true;
		yalwa.basics.ls_remove(key);
		return !support;
	}

	function suspicious(cn) {
		let regs = yalwa.basics.ls_get('regs', true) || [];
		return ls_disabled() || cn || regs.length >= 2;
	}

	function check_uac() {
		var deferred = jQuery.Deferred();
		var uac = yalwa.basics.ls_get('uac', true);
		var cn = false;
		if (uac && uac.length) {
			deferred.resolve(true);
		} else {
			deferred.resolve(false);
		}
		return deferred.promise();
	}

	pub.velocity_path = function() {
		return yalwa.v.js_path + 'external/velocity.including.ui.min.js';
	};

	pub.emoji = (function(pub) {

		var mapping_data;
		var path;
		var picker_selected_class = 'emojilist__selector--selected';

		pub = pub || {};

		pub.dynamic = function(name) {
			return '<img class="emojione" alt="" src="https://cdn.jsdelivr.net/emojione/assets/4.5/png/64/' + name + '.png">';
		};

		pub.autocomplete = function($element) {
			path = yalwa.basics.static_url('images') + '/emojione/4.5.0/';
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/jquery.textcomplete.js', function() {
				load_mapping_data().done(function() {
					on_strategy_load($element);
				});
			});
		};

		pub.picker_init = function($container, settings) {
			settings = settings || {};
			return jQuery.ajax({
				url: '/api/ajax/general/',
				type: 'get',
				data: {
					action: 'emoji_categories',
					is_dol: true
				},
				cache: true,
				dataType: 'html'
			}).done(function(html) {
				$container.append(html);
				picker_change_tab(jQuery('.js-emojione_head').first());
				jQuery('.js-emojione_head').on('click', function() {
					picker_change_tab(jQuery(this));
				});
				jQuery('.js-emojilist_close').on('click', yalwa.basics.emoji.picker_close);
				if (settings.swipe && typeof Hammer !== 'undefined') {
					var hammertime = new Hammer(jQuery('.js-emojilist')[0], {});
					hammertime.on('swipeleft', picker_tab_next).on('swiperight', picker_tab_prev);
				}
			});
		};

		pub.picker_toggle = function() {
			yalwa.basics.toggle(jQuery('.js-emojilist'));
		};

		pub.picker_close = function() {
			yalwa.basics.hide(jQuery('.js-emojilist'));
		};

		function picker_tab_next() {
			var $next = jQuery('.js-emojione_head').filter('.' + picker_selected_class).next();
			if (!$next.length) {
				$next = jQuery('.js-emojione_head').first();
			}
			picker_change_tab($next);
		}

		function picker_tab_prev() {
			var $prev = jQuery('.js-emojione_head').filter('.' + picker_selected_class).prev();
			if (!$prev.length) {
				$prev = jQuery('.js-emojione_head').last();
			}
			picker_change_tab($prev);
		}

		function picker_change_tab($new_tab) {
			jQuery('.js-emojione_head').removeClass(picker_selected_class);
			$new_tab.addClass(picker_selected_class);
			yalwa.basics.hide(jQuery('.js-emojilist_tab'));
			yalwa.basics.show(jQuery('.js-emojilist_tab').filter('[data-category="' + $new_tab.data('category') + '"]'));
			jQuery('.js-emojilist_content').scrollTop(0);
		}

		function load_mapping_data() {
			if (mapping_data) {
				var deferred = jQuery.Deferred();
				deferred.resolve();
				return deferred.promise();
			}
			return jQuery.ajax({
				url: '/js/external/emoji_strategy.json',
				dataType: 'json'
			}).done(function(emoji_strategy) {
				mapping_data = emoji_strategy;
			});
		}

		function on_strategy_load($element) {
			var config = {
				maxCount: 10
			};
			config.appendTo = jQuery('.js-mc_compose');
			$element.textcomplete([{
				match: /\B:([\-+\w]*)$/,
				search: on_search,
				template: template,
				replace: on_replace,
				index: 1
			}
			], config);
		}

		function check_for_hit(id, data, term) {
			if (data.shortname.indexOf(term) > -1) {
				return 1;
			}
			else {
				if ((data.shortname_alternates !== null) && (data.shortname_alternates.indexOf(term) > -1)) {
					return 2;
				}
				else if ((data.keywords !== null) && (data.keywords.indexOf(term) > -1)) {
					return 3;
				}
			}
		}

		function on_search(term, callback) {
			var results = [
				[],
				[],
				[]
			];
			jQuery.each(mapping_data, function(id, data) {
				var type = check_for_hit(id, data, term);
				if (type) {
					results[type - 1].push(id);
				}
			});

			if (term.length >= 3) {
				results[0].sort(sort_length);
				results[1].sort(sort_length);
				results[2].sort();
			}

			callback(results[0].concat(results[1]).concat(results[2]));
		}

		function sort_length(a, b) {
			return (a.length > b.length);
		}

		function template(id) {
			return '<img class="emojione" src="' + path + id + '.svg">';
		}

		function on_replace(id) {
			return String.fromCodePoint(parseInt(id, 16));
			// return '\u' + id;
			return mapping_data[id].shortname;
		}

		return pub;

	}(pub.emoji));

	pub.sw = (function(pub) {

		pub = pub || {};

		pub.init = function() {
			if (!pub.is_supported() || is_disabled()) {
				return;
			}
			window.addEventListener('appinstalled', () => {
				yalwa.basics.ga.event({
					category: 'PWA',
					action: 'installed',
					label: 'dating'
				});
			});
			register();
			setup_message_listener();
			if (window.matchMedia) {
				window.matchMedia('(display-mode: standalone)').addEventListener('change', (evt) => {
					let display_mode = 'browser';
					if (evt.matches) {
						display_mode = 'standalone';
					}
					if (display_mode === 'standalone' && yalwa.dol.app_promo) {
						yalwa.dol.app_promo.close_promo_on_headroom()
					}
				});
			}
		}

		pub.get_recent_pushes = function() {
			return new Promise(function(resolve, reject) {
				let msg_chan = new MessageChannel();
				msg_chan.port1.onmessage = function(event) {
					if (event.data.error) {
						reject(event.data.error);
					} else {
						resolve(event.data);
					}
				};
				if (navigator.serviceWorker.controller) {
					navigator.serviceWorker.controller.postMessage("get_new_pushes", [msg_chan.port2]);
				}
			});
		}

		pub.is_supported = function() {
			return 'serviceWorker' in navigator && navigator.cookieEnabled;
		};
		
		pub.name = function() {
			if (navigator &&
				navigator.serviceWorker &&
				navigator.serviceWorker.controller &&
				navigator.serviceWorker.controller.scriptURL
			) {
				const tmp = navigator.serviceWorker.controller.scriptURL.match(/\/([a-z_]+\.js)/);
				return tmp && tmp[1] ? tmp[1] : null;
			}
			return null;
		}
		
		function is_disabled() {
			if (yalwa.v.is_phonegap) {
				return true;
			}
			if(location.hostname.search(/^secure\./) !== -1) {
				return true;
			}
			if(location.hostname.search(/^www\.hashtag-dating\.com/) !== -1) {
				unregister('all');
				return true;
			}
			if(location.hostname.search(/^api\.hashtag-dating\.com/) !== -1) {
				unregister('all');
				return true;
			}
			if(['demo', 'international'].indexOf(yalwa.basics.get_routing()) !== -1) {
				return true;
			}
			return false;
		}

		function unregister(target) {
			let deferred = jQuery.Deferred();
			if(window.navigator && navigator.serviceWorker) {
				navigator.serviceWorker.getRegistrations()
					.then(function(registrations) {
						let promises = [];
						for(let registration of registrations) {
							if (target === 'all' || (target === 'locanto' && sw_is_locanto(registration))) {
								promises.push(registration.unregister());
							}
						}
						jQuery.when(promises).done(() => {
							deferred.resolve();
						});
					});
			}
			return deferred.promise();
		}

		function register() {
			if (navigator.serviceWorker.getRegistrations) {
				navigator.serviceWorker.getRegistrations().then(function(registrations) {
					if (registrations && registrations.length) {
						for (const registration of registrations) {
							if (sw_is_locanto(registration)) {
								// don't do this for now - we need a reliable way to identify if a PWA is Locanto or #Dating DEV-7446
								// unregister('locanto').done(() => {
								// 	yalwa.basics.reload();
								// });
								break;
							} else {
								if (registration.active) {
									registration.active.postMessage({
										'offline_cache_version': 10
									});
								}
							}
						}
					} else {
						do_registration();
					}
				});
			} else {
				do_registration();
			}
		}
		
		function sw_is_locanto(registration) {
			return registration && registration.active && registration.active.scriptURL && registration.active.scriptURL.search('/sw.js') !== -1;
		}
		
		function is_safari() {
			return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		}

		function do_registration() {
			navigator.serviceWorker.register('/sw_dol.js' + (is_safari() ? '?safari=7' : ''), {
				scope: '/' + yalwa.v.path_segment + '/dol',
				updateViaCache: 'all'
			}).then(on_registration);
		}
		
		function on_registration(registration) {
			if (registration.active) {
				registration.active.postMessage({
					'countryID': yalwa.v.countryID
				});
				registration.active.postMessage({
					'offline_cache_version': 10
				});
				registration.active.postMessage({
					'is_pwa': {value: yalwa.basics.is_pwa() ? (yalwa.v.is_ios ? 'ios' : 'android') : false}
				});
			}
		}

		function setup_message_listener() {
			if (navigator.serviceWorker.addEventListener) {
				navigator.serviceWorker.addEventListener('message', function(event) {
					switch(event.data.action) {
						case 'send_countryID':
							if (navigator.serviceWorker.controller) {
								navigator.serviceWorker.controller.postMessage({
									'countryID': yalwa.v.countryID
								});
							}
							break;
						case 'mc_poll':
							if (yalwa.basics.get_routing() === 'mc' || yalwa.chat) {
								yalwa.chat.polling_manual();
								yalwa.basics.webpush.process_recent_pushes_from_sw();
							}
							break;
						case 'push_notification_click':
							yalwa.basics.webpush.notification_click(JSON.parse(event.data.info), event.data.new_tab);
							break;
						case 'new_push_received':
							yalwa.basics.webpush.process_recent_pushes_from_sw();
							break;
					}
				});
			}
		}

		return pub;

	}(pub.sw));

	pub.webpush = (function(pub) {

		pub = pub || {};
		const recent_notifications_max = 10;
		const applicationServerKey = "BOTmdSh6+lEA9rKUBNRnSJGxyEZA0xe5UNL3/rnK/YZQgnfw+PLFLU6qHcmhTXiZmAZLCrmLovAGhfOxEqLdbtI=";
		const key_array = urlBase64ToUint8Array(applicationServerKey);

		let cache_key_base = 'webpush_endpoint';
		let cache_key_known = cache_key_base + '_known';
		let cache_key_confirmation = cache_key_base + '_confirmation';
		let cache_key_recent_notifications = cache_key_base + '_notifications';
		let notifications;

		pub.init = function() {
			pub.process_recent_pushes_from_sw();
			if (pub.prerequisites_met()) {
				watch_permission_changes();
			}
			if ((yalwa.v.webpush_ask_on_init || pub.is_granted())
				&& pub.is_supported()
				&& yalwa.basics.is_logged_in()
				&& !yalwa.v.is_phonegap
				&& !pub.is_denied()) {
				setTimeout(() => {
						pub.ask_or_update_existing(current_touchpoint()); // only usage of yalwa.v.webpush_ask_on_init, MC etc.
					}, 1000);
			}
		}

		pub.prerequisites_met = function() {
			if (pub.is_supported()
				&& yalwa.basics.is_logged_in()
				&& !yalwa.v.is_phonegap) {
				return true;
			}
			return false;
		};

		pub.unsubscribe = function() {
			if (!pub.is_supported() || pub.is_denied()) {
				return;
			}
			try {
				navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
					return serviceWorkerRegistration.pushManager.getSubscription();
				}).then(function(subscription) {
					if (subscription) {
						update_server(subscription, 'DELETE');
						subscription.unsubscribe();
					}
				});
			} catch (e) {
				yalwa.basics.sentry.submit_error(e);
			}
		};

		pub.ask_or_update_existing = function(touchpoint) {
			if (!pub.is_supported()) {
				return;
			}
			try {
				navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
					return serviceWorkerRegistration.pushManager.getSubscription().catch((e) => {
						// Sentry.captureException(e); // probably user-gesture needed
					});
				}).then(function(subscription) {
					if (subscription && pub.is_granted()) {
						is_endpoint_known(subscription).done((is_known) => {
							if (!is_known) {
								update_server(subscription, 'POST');
							}
						});
					} else {
						ask_permission(touchpoint);
					}
				});
			} catch (e) {
				yalwa.basics.sentry.submit_error(e);
			}
		}

		pub.stored_notifications = function() {
			// see sw.js received_pushes for structure
			return yalwa.basics.ls_get(cache_key_recent_notifications, true) || [];;
		}

		pub.not_available_info = function() {
			if (yalwa.v.is_phonegap) {
				return;
			}
			if (!pub.is_supported()) {
				show_unavailable_label();
			} else if(pub.is_denied()) {
				show_denied_label();
			}
		}

		pub.process_recent_pushes_from_sw = function() {
			if (!pub.is_supported() || !pub.is_granted()) {
				return;
			}
			navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
				// Let's see if you have a subscription already
				return serviceWorkerRegistration.pushManager.getSubscription();
			}).then(function(subscription) {
				if (!subscription) {
					return;
				}
				yalwa.basics.sw.get_recent_pushes().then(function(m) {
					if (!m) {
						return;
					}
					notifications = JSON.parse(m);
					if (!notifications || !notifications.length) {
						return;
					}
					if (yalwa.v.userID) {
						notifications = jQuery.grep(notifications, function(notification) {
							let u = notification.additionalData && notification.additionalData.userID ? notification.additionalData.userID : null;
							if (u && parseInt(yalwa.v.userID) !== parseInt(u)) {
								return false;
							}
							if (notification.additionalData.endpointID) {
								check_confirm_endpoint(notification.additionalData.endpointID);
							}
							return true;
						});
					}
					store_recent(notifications);
					jQuery.each(count_by_type(notifications), track_received);
				});
			});
		};

		pub.is_supported = function() {
			if (!yalwa.basics.sw.is_supported()) {
				return false;
			}
			if (!('PushManager' in window)) {
				return false;
			}
			if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
				return false;
			}
			if (typeof Notification !== 'function') {
				return false;
			}
			return true;
		}

		pub.is_default = function() {
			return permission_state() === 'default';
		}

		pub.is_denied = function() {
			return permission_state() === 'denied';
		}

		pub.is_granted = function() {
			return permission_state() === 'granted';
		}

		pub.notification_click = function(data, new_tab) {
			ga_clicked_pings(data.type_id).done(() => {
				if (new_tab) {
					return; // we've opened the url already
				}
				if (data.url_mobile) {
					if (data.url_mobile !== location.href) {
						yalwa.basics.navigate(data.url_mobile);
					}
				} else if (data.url) {
					yalwa.basics.navigate(data.url);
				}
			})
		}

		function permission_priming(touchpoint) {
			yalwa.basics.show(jQuery('.js-webpush_priming'));
			if (yalwa.basics.get_routing() === 'mc') {
				jQuery('.js-chat').scrollTop(0);
			}
			jQuery('.js-webpush_priming_allow').on('click', () => {
				pub.ask_or_update_existing(touchpoint);
			});
		}

		function ga_clicked_pings(type) {
			return yalwa.basics.ga.event({
				category: 'push notification',
				action: 'clicked push',
				label: type + '|' + '3'
			});
		}

		function show_denied_label() {
			const $label_denied = jQuery('.js-webpush_disallowed_info');
			if ($label_denied.length) {
				$label_denied.removeClass('hidden');
			}
		}

		function show_unavailable_label() {
			const $label_unavailable = jQuery('.js-no_webpush_support_info');
			if ($label_unavailable.length) {
				$label_unavailable.removeClass('hidden');
			}
		}

		function permission_state() {
			if (typeof Notification === 'function' && Notification.permission !== 'undefined') {
				return Notification.permission;
			} else {
				return null;
			}
		}

		// Dating serves its chat surface under routing 'dol', so the surface has to be
		// read from the tab bar. The inbox in the Locanto shell runs the Locanto
		// bundle and gets its touchpoint from page_mc instead.
		function current_touchpoint() {
			if (yalwa.mobile && yalwa.mobile.htabs && typeof yalwa.mobile.htabs.current === 'function' && yalwa.mobile.htabs.current() === 'chats') {
				return 'dol-mc-initial';
			}
			return 'my-locanto-mobile';
		}

		// Touchpoint of the last ask started on this page. The listener below must
		// attribute a grant to the same touchpoint as the ask that caused it,
		// otherwise the grant is tracked twice under two different dedupe keys.
		let asked_touchpoint = null;

		// Chrome 155+ on Android shows the notification prompt as an auto-hiding card
		// with a second opt-in entry point in Site Controls. Without this listener a
		// grant made there is only picked up on the next page load.
		function watch_permission_changes() {
			if (!navigator.permissions || typeof navigator.permissions.query !== 'function') {
				return;
			}
			try {
				navigator.permissions.query({name: 'notifications'}).then(function(permission_status) {
					permission_status.onchange = function() {
						if (permission_status.state === 'granted') {
							const touchpoint = asked_touchpoint || current_touchpoint();
							track_genstats(touchpoint, 'granted');
							pub.ask_or_update_existing(touchpoint);
						}
					};
				}).catch(function() {
					// permissions.query for 'notifications' is unsupported in some browsers
				});
			} catch (e) {
				yalwa.basics.sentry.submit_error(e);
			}
		}

		function ask_permission (touchpoint) {
			try {
				navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
					if (serviceWorkerRegistration.pushManager) {
						let track_it = false;
						if (pub.is_default()) {
							track_genstats(touchpoint, 'asked');
							track_it = true;
							asked_touchpoint = touchpoint;
						}
						const denied_before_already = pub.is_denied();
						serviceWorkerRegistration.pushManager.subscribe({
							userVisibleOnly: true,
							applicationServerKey: key_array
						}).then(function(subscription) {
							if (subscription) {
								on_allow(touchpoint, track_it);
								update_server(subscription, 'POST');
							} else {
								on_disallow(touchpoint, denied_before_already);
								return false;
							}
						}, function(error) {
							if (pub.is_denied()) {
								on_disallow(touchpoint, denied_before_already);
							} else {
								// could be firefox or other browsers needing user gesture/interactions
								permission_priming('dol-mc-priming');
							}
						});
					}
				}, function(error) {
					yalwa.basics.sentry.submit_error(error);
				})
			} catch (e) {
				if (Notification.permission === 'denied') {
					// console.warn('Notifications are denied by the user.');
				} else {
					yalwa.basics.sentry.submit_error(e);
				}
			}

		};

		function update_server(subscription, method) {
			let key = subscription.getKey('p256dh');
			let token = subscription.getKey('auth');
			let data = {
				'method': method,
				'endpoint': subscription.endpoint,
				'is_dol': true,
				'key': key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
				'token': token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
				'fingerprintID': yalwa.basics.fingerprint.getID() || 0
			}
			let url = '/api/ajax/push_subscription';
			yalwa.basics.beacon(url, data);
		}

		function is_endpoint_known(subscription) {
			let is_known_cache = yalwa.basics.ss_get(cache_key_known, true) || {};
			if (yalwa.basics.session_storage_age() > 60 * 60) {
				is_known_cache = {};
			}
			let deferred = jQuery.Deferred();
			if (!subscription || !subscription.endpoint) {
				deferred.resolve(false);
			} else {
				if (is_known_cache[subscription.endpoint]) {
					deferred.resolve(true);
				} else {
					jQuery.ajax({
						url: '/api/ajax/push_subscription',
						type: 'post',
						data: {
							method: 'POST',
							check_subscription: true,
							endpoint: subscription.endpoint
						},
						dataType: 'json'
					}).done(function(r) {
						if (r.status === 'subscribed') {
							is_known_cache[subscription.endpoint] = true;
							deferred.resolve(true);
						} else {
							delete is_known_cache[subscription.endpoint];
							deferred.resolve(false);
						}
						yalwa.basics.ss_set(cache_key_known, is_known_cache);
					});
				}
			}
			return deferred.promise();
		}

		function urlBase64ToUint8Array(base64String) {
			let padding = '='.repeat((4 - base64String.length % 4) % 4);
			let base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

			let rawData = window.atob(base64);
			let outputArray = new Uint8Array(rawData.length);

			for (let i = 0; i < rawData.length; ++i) {
				outputArray[i] = rawData.charCodeAt(i);
			}

			return outputArray;
		}

		function check_confirm_endpoint(endpointID) {
			let cache = yalwa.basics.ls_get(cache_key_confirmation, true) || {};
			if (!cache[endpointID]) {
				confirm_endpoint(endpointID);
				cache[endpointID] = true;
				yalwa.basics.ls_set(cache_key_confirmation, cache);
			}
		}

		function confirm_endpoint(endpointID) {
			return jQuery.post({
				url: '/api/ajax/push_subscription',
				data: {
					confirm_subscription: true,
					endpointID: endpointID
				}
			});
		}

		function store_recent(notifications) {
			let cache = yalwa.basics.ls_get(cache_key_recent_notifications, true) || [];
			jQuery.each(notifications, function (index, notification) {
				if (notification.message) {
					cache.push(notification);
				}
			});
			if (cache.length > recent_notifications_max) {
				cache = cache.slice(cache.length - recent_notifications_max, cache.length);
			}
			if (cache.length) {
				yalwa.basics.show(jQuery('.js-push_history_burger'));
			}
			yalwa.basics.ls_set(cache_key_recent_notifications, cache);
		}

		function count_by_type(notifications) {
			let track_events = {};
			jQuery.each(notifications, function(index, notification) {
				let type = notification.type_id;
				if (!track_events.type) {
					track_events[type] = 0;
				}
				track_events[type]++;
			});
			return track_events;
		}

		function on_allow(touchpoint, track_it) {
			jQuery('.js-webpush_priming,.js-webpush_ask,.js-webpush_denied').remove();
			if (track_it) {
				track_allow(touchpoint);
			}
		}

		function on_disallow(touchpoint, denied_before_already) {
			jQuery('.js-webpush_priming,.js-webpush_denied').remove();
			if (!denied_before_already) {
				track_disallow(touchpoint);
			}
		}

		function track_disallow(touchpoint) {
			yalwa.basics.ga.event({
				category: 'webpush_mc',
				action: 'disallowed-native',
				label: touchpoint + ' | ' + yalwa.basics.get_routing()
			});
			track_genstats(touchpoint, 'denied');
		}

		function track_allow(touchpoint) {
			yalwa.basics.ga.event({
				category: 'webpush_mc',
				action: 'allowed-native',
				label: touchpoint + ' | ' + yalwa.basics.get_routing()
			});
			track_genstats(touchpoint, 'granted');
		}

		function track_genstats(touchpoint, metric) {
			const pg = yalwa.basics.ss_get('push_genstats', true) || {};
			const k = touchpoint + '_' + metric;
			if (pg[k]) { // log once per session
				return;
			}
			if (yalwa.basics.tracking_quota_add_and_check()) {
				return;
			}
			pg[k] = 1;
			yalwa.basics.ss_set('push_genstats', pg);
			yalwa.basics.beacon('/api/ajax/track', {
				t: 'push',
				touchpoint: touchpoint,
				metric: metric,
				app_type: yalwa.basics.app_type()
			});
		}

		function track_received(type_name, count) {
			yalwa.basics.ga.event({
				category: 'push notification',
				action: 'received push',
				label: type_name + '|' + '3',
				value: count
			});
		}

		return pub;

	}(pub.webpush));

	pub.auth = (function(pub) {

		var module;

		pub = pub || {};

		pub.init = function() {
			module = yalwa.mobile.auth;
			module.update_login_handlers();
			module.update_logout_handlers();
			if (module.autoload()) {
				module.show_dialog();
			}
		};

		pub.credential_api_support = function() {
			if (!window.PasswordCredential) {
				return false;
			}
			if (!window.PublicKeyCredential) {
				return false;
			}
			if (!navigator.credentials) {
				return false;
			}
			if (typeof(navigator.credentials.get) !== 'function') {
				return false;
			}
			return true;
		};

		pub.register = function(email) {
			return jQuery.ajax({
				type: 'post',
				url: '/api/ajax/general',
				dataType: 'json',
				data: {
					action: 'register_attempt',
					email: email,
					is_dol: yalwa.v.is_dol
				}
			});
		};

		pub.login = function({ email, pw, keep, csrf_key, csrf_value, url = null, otp_token = null, remember_browser = false, fp_hash = null}) {
			let msgID = null;
			if (yalwa.basics.get_isset('paf') && yalwa.basics.get_isset('manage')) {
				if (yalwa.basics.get_get('continue')) {
					let result = yalwa.basics.get_get('continue').match(/manage\/([0-9]+)\//);
					if (result && result[1]) {
						msgID = result[1];
					}
				}
			}
			var data = {
				action: 'login_attempt',
				email: email,
				pwd: pw,
				stay_logged_in: keep,
				is_dol: yalwa.v.is_dol,
				msgID: msgID,
				otp_token: otp_token,
				remember_browser: remember_browser,
				fp_hash:fp_hash
			};
			data[csrf_key] = csrf_value;

			return jQuery.ajax({
				type: 'post',
				url: '/api/ajax/general',
				dataType: 'json',
				data: data,
				xhrFields: {
					withCredentials: true
				}
			});
		};

		pub.logout = function() {
			return jQuery.ajax({
				type: 'post',
				url: '/api/ajax/general',
				dataType: 'json',
				data: {
					action: 'logout_attempt'
				},
				xhrFields: {
					withCredentials: true
				}
			});
		};
		
		pub.touchpoint_parameter = function(id) {
			return 'tp';
		};
		
		return pub;

	}(pub.auth));

	pub.is_app = function() {
		return yalwa.v.is_phonegap || yalwa.basics.is_pwa();
	};
	
	pub.is_iap_active = function () {
		// https://yalwa.atlassian.net/browse/DEV-8923
		// https://yalwa.atlassian.net/browse/DEV-8917
		
		if (yalwa.v.countryID === 48) {
			return false;
		}
		
		return (yalwa.basics.is_dol_app() && yalwa.basics.is_dol_app() === 'dol_android' && yalwa.basics.dol_app_version() >= yalwa.v.iap_android_app_version)
			|| (yalwa.basics.is_dol_app() && yalwa.basics.is_dol_app() === 'dol_ios' && yalwa.basics.dol_app_version() >= yalwa.v.iap_ios_app_version);
	};
	/**
	 * @desc method loads tippy library JavaScript and CSS files
	 * @returns {*}
	 */
	pub.load_tippy = function() {
		var deferred = jQuery.Deferred();
		yalwa.basics.load_js('https://unpkg.com/@popperjs/core@2.1.1/dist/umd/popper.min.js', () => {
			yalwa.basics.load_js('https://unpkg.com/tippy.js@6.1.0/dist/tippy-bundle.umd.min.js', () => {
				deferred.resolve(true);
			});
		});
		yalwa.basics.load_css('https://unpkg.com/tippy.js@6.1.0/dist/tippy.css');
		return deferred.promise();
	};

	function yicon_modifier_get($element) {
		var bem_class;
		let cl = $element.attr('class');
		if (cl) {
			jQuery.each(cl.split(' '), (i, name) => {
				if (!bem_class && name.indexOf('js-') !== 0 && name.indexOf('__') !== -1) {
					bem_class = name;
				}
			});
		}
		return bem_class ? bem_class.replace(/--.*/, '') : null;
	}

	function bem_modifier_get($element) {
		let bem_class;
		if ($element.data('bem')) {
			bem_class = $element.data('bem');
		} else {
			// search for the first class name without a "js-" prefix and not being a modifier itself
			jQuery.each($element.attr('class').split(' '), (i, name) => {
				if (!bem_class && name.indexOf('js-') !== 0 && name.indexOf('--') === -1) {
					bem_class = name;
				}
			});
		}
		return bem_class;
	}

	function modifier_helper(class_final, $element, action) {
		action = action || 'toggle';
		if (action === 'add') {
			$element.addClass(class_final);
		} else if (action === 'remove') {
			$element.removeClass(class_final);
		} else if (action === 'toggle') {
			$element.toggleClass(class_final);
		}
	};


	pub.bem_modifier = function($element, modifier, action) {
		modifier_helper(bem_modifier_get($element) + '--' + modifier, $element, action);
	};

	pub.yicon_modifier = function($element, modifier, action) {
		if (yalwa.v.yimage_active) {
			pub.yimage_modifier_fallback($element, modifier, action);
			return;
		}
		let c = yicon_modifier_get($element);
		if (c) {
			modifier_helper(c + '--' + modifier, $element, action);
		}
	};
	const yimage_name_pattern = /\/([^\/]+)\.svg$/;
	
	pub.yimage_modifier_fallback = function($element, modifier, action) {
		if (!$element.length) {
			return;
		}
		const name = yimage_name_get($element);
		if (!name) {
			return;
		}
		const [name_root, existing_modifier] = name.split('--');
		let name_final;
		switch(action) {
			case 'add':
				name_final = name_root + '--' + modifier;
				break;
			case 'remove':
				name_final = name_root;
				if (existing_modifier === modifier) {
					name_final = name_root;
				} else {
					name_final = name;
				}
				break;
				default:
					if (existing_modifier === modifier) {
						name_final = name_root;
					} else {
						name_final = name_root + '--' + modifier;
					}
				break;
		}
		pub.yimage_change(name_final, $element);
	};
	
	pub.yimage_change = function(name, $element) {
		const src = $element.attr('src');
		const new_src = src.replace(yimage_name_pattern, `/${name}.svg`);
		if (new_src !== src) {
			$element.attr('src', new_src);
		}
	}
	function yimage_name_get($element) {
		const src = $element.attr('src');
		if (!src) {
			return null;
		}
		const match = src.match(yimage_name_pattern);
		if (match) {
			return match[1];
		} else {
			return null;
		}
	}

	pub.get_datetime_format = function() {
		switch(yalwa.v.countryID) {
			case 1:
				return 'MM.dd.yyyy';
			case 5:
			case 6:
			case 9:
				return 'yyyy.MM.dd';
			default:
				return 'dd.MM.yyyy';
		}
	}

	/**
	 * avoids one word on the last line by default
	 * more words also can be joined using second param numWords
	 * @param $element
	 * @param numWords
	 * @see https://stackoverflow.com/a/32895944/6345257
	 */
	pub.no_more_lonely_words = function($element, numWords = 2) {
		if (!$element || !$element.length) {
			return;
		}
		// Split the text content of element into an array
		const textArray = $element.text().split(" ");
		// Remove the last n words and join them with a none breaking space
		const lastWords = textArray.splice(-numWords, numWords).join("&nbsp;");
		// Join it all back together and replace the existing
		// text with the new text
		const textMinusLastWords = textArray.join(" ");
		$element.html(textMinusLastWords + " " +  lastWords);
	}

	pub.overlay = (function(pub) {

		pub = pub || {};

		let current_shown;

		pub.init = function() {
			if (typeof Set === 'undefined') {
				return;
			}
			current_shown = new Set();
			check_overlays_visible_immediately();
		}

		function check_overlays_visible_immediately() {
			if (jQuery('.js-pwa_promotion_topbar').length) {
				pub.register('pwa_head');
			}
		}

		pub.current_count = function() {
			return current_shown ? current_shown.size : 0;
		};

		pub.register = function(id, non_obtrusive) {
			if (non_obtrusive && pub.current_count() > 0) {
				return false;
			}
			if (current_shown && !current_shown.has(id)) {
				current_shown.add(id);
				return true;
			}
			return false;
		};

		pub.unregister = function(id) {
			if (current_shown && current_shown.has(id)) {
				current_shown.delete(id);
				return true;
			}
			return false;
		}

		return pub;

	}(pub.overlay));

	pub.tracking_quota_add_and_check = function() { // precaution when some loop is going wild
		const key = 'tracking_pings' + (Math.floor(yalwa.basics.unix() / 300)); // check in 5 minute intervals
		const threshold = 50;
		const count = parseInt(yalwa.basics.ss_get(key)) || 0;
		yalwa.basics.ss_set(key, count + 1);
		const too_much = count > threshold && !location.port;
		return too_much;
	};

	pub.after_logout_handler = function() {
		if (yalwa.v.is_phonegap && !yalwa.v.is_dol_app) {
			yalwa.mobile.cordova.cordova_send({action: 'logout', params: {}});
		}

		ls_flush();
		cookie_flush();
		
		//chrome will showing on back/forward button usage cached html. DEV-1069
		if (window.chrome) {
			yalwa.basics.state.prevent_back_button_caching(yalwa.v.chp_url);
		}
	};
	
	pub.get_css_val = function(variable, $elem = document.body) {
		return getComputedStyle($elem).getPropertyValue(variable);
	};
	
	pub.datalayer_push = function(data) {
			let debug = location.port && yalwa.basics.ls_get('log_ga');
		
		if (debug) {
			console.log(data);
		}
		
		if (data) {
			dataLayer.push(data);
		}
		
		if (yalwa.v.is_dol_app) {
			yalwa.basics.app_module_load_handler.is_loaded.done(function() {
				yalwa.mobile.cordova_dol.event_logging.send(data);
			})
		}
	};
	
	pub.get_lines_count = function($elem) {
		if (!$elem.length) {
			return;
		}
		let div_height = $elem.outerHeight();
		let line_height = +$elem.css('line-height').replace('px', '');
		return Math.round(div_height / line_height);
	};
	
	function DEV_9572_increase() {
		if (yalwa.basics.ls_get('DEV_9572') !== null) {
			yalwa.basics.ls_set('DEV_9572', parseInt(yalwa.basics.ls_get('DEV_9572')) + 1);
		}
	}
	
	pub.simple_auto_slide = function(args) {
		const default_options = {
			css_prefix: '',
			container_class: 'js-simple_auto_slide',
			element_class: 'js-simple_auto_slide_item',
			timeout: 4000,
			arrows: {
				append_to: false,
				enabled: false,
				size: 9,
				directions: {
					left: {
						icon: 'arrowleft'
					},
					right: {
						icon: 'arrowright'
					}
				}
			},
			clickable: true
		};
		let id,
			error,
			options,
			$container,
			$slide_items,
			$bullet_container,
			$arrow_container,
			$elements,
			slide_index = 0,
			scheduled_slide,
			slide_height = 0,
			hammer,
			slide_url,
			$element_with_url;
		const visibility_change_handler = () => document.hidden ? stop() : slide();
		const stop = () => clearTimeout(scheduled_slide);
		const hide_all = () => yalwa.basics.hide($elements);
		const determine_index = (direction) => {
			switch(direction) {
				case 'previous':
					return slide_index - 1 < 0 ? $elements.length - 1 : slide_index - 1;
				case 'next':
					return slide_index + 1 > $elements.length - 1 ? 0 : slide_index + 1;
			}
		};
		const set_current_index = index => {
			slide_index = index;
		};
		const slide = () => {
			stop();
			hide_all();
			reset_bullets();
			const next_index = determine_index('next');
			yalwa.basics.show(jQuery($elements[next_index]));
			jQuery($elements[next_index]).velocity('transition.slideRightIn', {duration: 250, display: 'grid'});
			jQuery($container.find('.js-bullet')[next_index]).addClass('selected');
			scheduled_slide = setTimeout(() => slide(), options.timeout);
			set_current_index(next_index);
		};
		const slide_to_previous = () => {
			stop();
			hide_all();
			reset_bullets();
			const next_index = determine_index('previous');
			yalwa.basics.show(jQuery($elements[next_index]));
			jQuery($elements[next_index]).velocity('transition.slideLeftIn', {duration: 250, display: 'grid'});
			jQuery($container.find('.js-bullet')[next_index]).addClass('selected');
			scheduled_slide = setTimeout(() => slide(), options.timeout);
			set_current_index(next_index);
		};
		const reset_bullets = () => $container.find('.js-bullet').removeClass('selected');
		const add_bullets = () => {
			$bullet_container = jQuery('<div class="js-bullet_container"></div>').addClass(options.css_prefix + 'simple_auto_slide_bullet_container');
			$bullet_container.appendTo($container);
			for (let i = 0; i < $elements.length; i++) {
				let $bullet = jQuery('<div class="js-bullet"></div>').addClass(options.css_prefix + 'simple_auto_slide_bullet');
				$bullet.appendTo($bullet_container);
			}
			
		};
		const add_arrows = () => {
			const $append_to = options.arrows.append_to || $container;
			$arrow_container = jQuery('<div class="js-arrow_container"></div>').addClass(options.css_prefix + 'simple_auto_slide_arrow_container');
			$arrow_container.appendTo($append_to);
			for (const [direction, properties] of Object.entries(options.arrows.directions)) {
				let icon = yalwa.basics.yicon(properties.icon, {pixel: options.arrows.size});
				let icon_html = '<div class="js-arrow" data-direction="' + direction + '">' + icon + '</div>';
				let $arrow = jQuery(icon_html).addClass(options.css_prefix + 'simple_auto_slide_arrow');
				$arrow.appendTo($arrow_container);
				jQuery('.js-arrow[data-direction="' + direction + '"]').on('click', arrow_click_handler.bind(this, direction));
			}
		};
		const arrow_click_handler = (direction, event) => {
			switch(direction) {
				case 'left':
					slide_to_previous();
					break;
				case 'right':
					slide();
					break;
			}
		};
		const slide_click_handler = (event) => {
			slide_url = jQuery(event.currentTarget).find('a').prop('href');
			if (slide_url) {
				yalwa.basics.navigate(slide_url);
			}
		};
		const handle_ovw_urls = _ => {
			$elements.each(function() {
				let url = false;
				$element_with_url = jQuery(this).find('a');
				slide_url = $element_with_url.prop('href');
				if (slide_url) {
					url = new URL(slide_url);
				}
				if (slide_url && url && url.pathname.startsWith('/m/')) {
					$element_with_url.prop('href', slide_url.replace('/m/', `/${yalwa.v.path_segment}/`));
				}
			});
		};
		const add_click_handler = _ => $elements.on('click', slide_click_handler);
		const add_pan_events = _ => {
			hammer = new Hammer($container[0], {});
			hammer.get('pan').set({direction: Hammer.DIRECTION_HORIZONTAL, threshold: 10});
			hammer.on('panleft panright', pan).on('panend', pan_end);
		};
		const pan = event => {
			let delta = event.deltaX;
			const $panned_item = jQuery(event.target).closest('.js-simple_auto_slide_item');
			window.requestAnimationFrame(function() {
				$panned_item.data('delta', delta).css({transform: 'translateX(' + delta.toString() + 'px)'});
			});
		};
		const pan_end = event => {
			event.additionalEvent === 'panleft' ? slide() : slide_to_previous();
		};
		const determine_slide_height = $element => {
			if (slide_height < $element.height()) {
				slide_height = $element.height();
			}
		};
		const set_slide_height = _ => {
			$slide_items.height(slide_height);
		};
		const show = () => {
			yalwa.basics.show($container);
			yalwa.basics.show($arrow_container);
		};
		const hide = () => {
			yalwa.basics.hide($container);
			yalwa.basics.hide($arrow_container);
		};
		const start = () => slide();
		const get_id = () => id;
		const get_error = () => console.log(error);
		const init_visibility_observer = ($container) => {
			const options = {
				rootMargin: '0px',
				threshold: 0.9 // safari fix the threshold only reach .9xx
			};
			function observer_callback(changes, observer) {
				changes.forEach(change => {
					// visible
					if(change.intersectionRatio > 0.9) {
						determine_slide_height(jQuery(change.target));
						if (observer.last) {
							set_slide_height();
						}
						// we are done also remove the visibility listener from element
						observer.unobserve(change.target);
					}
				});
			}
			$slide_items.each(function(index) {
				let $element = jQuery(this);
				let observer = new IntersectionObserver(observer_callback, options);
				observer.index = index;
				if ($slide_items.length - 1 === index) {
					observer.last = true;
				}
				observer.observe($element[0]);
			});
		};
		
		options = jQuery.extend(true, default_options, args || {});
		$container = jQuery('.' + options.container_class);
		$slide_items = $container.find('.js-simple_auto_slide_item');
		const date = new Date();
		id = date.getTime();
		this.get_id = get_id;
		this.get_error = get_error;
		if ($container.data('initialized')) {
			error = 'instance with id ' + this.get_id() + ' can not be initialized, Reason: already an instance initialized on this container_class with id ' + $container.data('initialized') + '. If you need multiple instances, to control them separately please use a unique container_class name.';
			this.start = get_error;
			this.hide = get_error;
			this.show = get_error;
			return;
		}
		$container.data('initialized', id);
		$elements = $container.find('.' + options.element_class);
		if (options.clickable) {
			handle_ovw_urls();
			add_click_handler();
		}
		set_current_index($elements.length);
		init_visibility_observer($container);
		add_bullets();
		if (options.arrows.enabled) {
			add_arrows();
		}
		document.addEventListener("visibilitychange", visibility_change_handler);
		add_pan_events();
		this.start = _ => {
			start();
			return this;
		};
		this.hide = _ => {
			hide();
			return this;
		};
		this.show = _ => {
			show();
			return this;
		};
		this.stop = _ => {
			stop();
			return this;
		};
		this.slide = _ => {
			slide();
			return this;
		};
	};
	
	async function crypto_sign(message) {
		// the JS-internal SubtleCrypto Web API is used for generating an HMAC
		// signature. it is supported by most browsers:
		// https://caniuse.com/mdn-api_crypto_subtle
		// https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto
		
		// first, we generate a random text string. this will be returned
		// by the function and passed on with the AJAX request. we're only signing
		// to deter potential attackers by making the attack more tedious to do
		const key = Math.random().toString(36).slice(2);
		
		// now, encode and convert the random string into an SHA-256 HMAC CryptoKey
		const encodedKey = new TextEncoder().encode(key);
		const crypto_key = await window.crypto.subtle.importKey(
			'raw',
			encodedKey,
			{
				// these settings are repeated in php ajax_service->validate_signature()
				name: 'HMAC',
				hash: {name: 'SHA-256'}
			},
			true,
			['sign', 'verify']
		);
		
		// now encode the message (in this case, the URL and data passed to it) and
		// turn it into an HMAC signature using the CryptoKey
		const encodedText = new TextEncoder().encode(message);
		const signature = await window.crypto.subtle.sign('HMAC', crypto_key, encodedText);
		
		// finally, return both the random text string
		// and the signature (as a base64 string)
		return {
			key: key,
			sig: btoa(String.fromCharCode(...new Uint8Array(signature)))
		}
	}
	
	// Function to sort an object by its keys
	function sort_object_by_keys(obj) {
		// Get the keys and sort them
		const sorted_keys = Object.keys(obj).sort();
		
		// Create a new object with the sorted keys
		const sorted_obj = {};
		sorted_keys.forEach(key => {
			sorted_obj[key] = obj[key];
		});
		
		return sorted_obj;
	}
	
	pub.ajaxservice = async function({
										 type = 'GET',
										 resource = 'general',
										 service = null,
										 action = null,
										 identifier = null,
										 data = {},
										 dataType = 'json',
										 csrf = '',
										 cache = true,
										 dating_specific = true,
									 } = {}) {
		if (!resource || !action) {
			return null;
		}
		
		let url = null
		const path = dating_specific ? '/api/dating/' : '/api/service/';
	    if(service){
			url = path + resource + '/' + service +'/' + action + '/';
		}else {
			url = path + resource +'/' + action + '/';
		}
		if (identifier) {
			url += identifier + '/';
		}
		
		// we will build the same message in class ajax_service from the
		// REQUEST_URI and valid uip parameters
		// this will also ensure that only allowed (and validated) parameters
		// can be used in these requests
		let message = url + '?' + new URLSearchParams(sort_object_by_keys(data)).toString();
		
		const crypto_key_sig = await crypto_sign(message);
		
		// these header names are repeated in class ajax_service as
		// HTTP_X_Y_KEY and HTTP_X_Y_SIG
		let headers = {
			'x-y-key': crypto_key_sig.key,
			'x-y-sig': crypto_key_sig.sig,
		}
		
		if (csrf) {
			// this header is accessed in class uip_csrf
			// as HTTP_X_Y_CSRF and use as the token
			headers['x-y-csrf'] = csrf;
		}
		
		let ajax_settings = {
			type: type,
			url: url,
			data: data,
			dataType: dataType,
			headers: headers
		};
		
		if (type === 'GET' && !cache) {
			ajax_settings['cache'] = cache;
		}
		
		return jQuery.ajax(ajax_settings);
	}
	
	let lock_count = 0;
	let saved_scroll_y = 0;
	let saved_right_pad = '';
	let saved_position = '';
	let saved_top = '';
	let saved_width = '';
	pub.scroll_lock = function() {
		if (++lock_count > 1) {
			return;
		}
		saved_scroll_y = window.scrollY || 0;
		const body = document.body;
		const sbw = window.innerWidth - document.documentElement.clientWidth;
		saved_right_pad = body.style.paddingRight;
		saved_position = body.style.position;
		saved_top = body.style.top;
		saved_width = body.style.width;
		
		if (sbw > 0) { // avoid layout shift from scrollbar disappearance
			const computedPad = parseFloat(getComputedStyle(body).paddingRight) || 0;
			body.style.paddingRight = `${computedPad + sbw}px`;
		}
		// freeze body at current scroll position
		body.style.position = 'fixed';
		body.style.top = `-${saved_scroll_y}px`;
		body.style.width = '100%';
	}
	
	pub.scroll_unlock = function() {
		if (--lock_count > 0) {
			return;
		}
		const body = document.body;
		
		// restore styles
		body.style.paddingRight = saved_right_pad;
		body.style.position = saved_position;
		body.style.top = saved_top;
		body.style.width = saved_width;
		window.scrollTo(0, saved_scroll_y); // restore scroll position
	}
	
	return pub;

}(yalwa.basics));

yalwa.basics.init_wrapper(yalwa.basics.init, 'jquery.min.js');
